(function () {
  'use strict';

  var API_CACHE = new Map();
  var MEMBER_LOOKUP_CACHE = new Map();
  var MONDAY_BANK_HOLIDAY_DATES = new Set();
  var SAVED_DETAILS_KEY = 'hbc-booking-details-v1';
  var SAVED_DETAILS_MAX_AGE = 30 * 24 * 60 * 60 * 1000;
  var DEFAULT_TIMETABLE_API_URL = 'https://script.google.com/macros/s/AKfycbz1Sr0CdhP8RcHr6B-O9B8grDbAbFp-De4_pRqdqmUfxz6g1tn5iXqGvScgr_BNx5El/exec';
  var WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var DAY_INDEX = WEEKDAYS.reduce(function (map, day, index) {
    map[day.toLowerCase()] = index;
    return map;
  }, {});
  var LONDON_ZONE = 'Europe/London';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var ADULT_CLASS_ORDER = [
    'punch bags',
    'pads',
    'physical fitness',
    'boxing technique',
    'sparring',
    'ladies only boxing'
  ];
  var ONE_TO_ONE = {
    name: 'One-to-One Personal Coaching', price: 60, durationMinutes: 60,
    goals: ['Improve my boxing skills', 'Improve my general fitness', 'Lose weight and improve body composition', 'Build strength and conditioning', 'Prepare for competition', 'Improve my health and movement', 'Build confidence', 'Learn self-defence', 'Reduce stress and feel better', 'Return to training after time away', 'Return safely after injury', 'Something else'],
    experience: ['I do not want boxing included in my training', 'Complete beginner', 'I have completed a few sessions', 'I train recreationally', 'I have amateur boxing experience', 'I compete or am preparing to compete'],
    fitness: ['Just getting started', 'Average', 'Good', 'Very good', 'High-performance', 'Not sure'],
    focus: ['Boxing skills and technique', 'Pad work and boxing combinations', 'General fitness and conditioning', 'Strength, power and athletic performance', 'Weight management and body composition', 'Endurance and cardiovascular fitness', 'Mobility, movement and general health', 'Confidence and returning to exercise', 'Sparring and competition preparation', 'Something else'],
    frequency: ['One session', 'Once a week', 'Twice a week', 'Three or more times a week', 'I am not sure yet'],
    ages: ['Under 16', '16-17', '18-25', '26-40', '41-60', '61+']
  };
  var ONE_TO_ONE_PHONE_ONLY = true;
  var MEMBERSHIP = {
    name: 'Monthly Unlimited Membership',
    price: 130
  };
  var ANALYTICS_QUEUE = [];
  var ANALYTICS_TIMER = null;

  function analyticsAllowed() {
    try {
      return !!(window.Shopify && window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed());
    } catch (error) {
      return false;
    }
  }

  function analyticsSession() {
    var key = 'hbc-analytics-session-v1';
    try {
      var existing = window.sessionStorage.getItem(key);
      if (existing) return existing;
      var value = window.crypto && window.crypto.randomUUID ?
        window.crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2);
      window.sessionStorage.setItem(key, value);
      return value;
    } catch (error) {
      return '';
    }
  }

  function trackBookingEvent(instance, eventName, extra) {
    if (!analyticsAllowed() || !instance || !instance.apiUrl) return;
    var details = extra || {};
    var referrerHost = '';
    try { referrerHost = document.referrer ? new URL(document.referrer).hostname : ''; } catch (error) {}
    ANALYTICS_QUEUE.push({
      apiUrl: instance.apiUrl,
      session: analyticsSession(),
      event: eventName,
      page: window.location.pathname,
      className: details.className || (instance.selectedClass && instance.selectedClass.name) || '',
      journey: instance.journey || 'group',
      mode: instance.mode || '',
      device: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
      referrerHost: referrerHost
    });
    window.clearTimeout(ANALYTICS_TIMER);
    ANALYTICS_TIMER = window.setTimeout(flushBookingAnalytics, 800);
  }

  function flushBookingAnalytics() {
    if (!ANALYTICS_QUEUE.length) return;
    var queued = ANALYTICS_QUEUE.splice(0, 20);
    var apiUrl = queued[0].apiUrl;
    var events = queued.filter(function (item) { return item.apiUrl === apiUrl; }).map(function (item) {
      delete item.apiUrl;
      return item;
    });
    fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({ type: 'analytics-events', events: events }),
      redirect: 'follow',
      credentials: 'omit',
      keepalive: true
    }).catch(function () {});
  }

  function emptyOneToOnePlan() {
    return { serviceType: 'one-to-one', price: 60, durationMinutes: 60, primaryGoals: [], customGoal: '', boxingExperience: '', fitnessLevel: '', focusAreas: [], customFocus: '', hasHealthConsiderations: null, healthConsiderations: '', trainingFrequency: '', additionalNotes: '', ageRange: '', firstTime: '' };
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  }

  function normaliseText(value) {
    return typeof value === 'string' ? value.trim().replace(/\s+/g, ' ') : '';
  }

  function classOrderIndex(group) {
    var index = ADULT_CLASS_ORDER.indexOf(group.name.toLocaleLowerCase('en-GB'));
    return index === -1 ? ADULT_CLASS_ORDER.length : index;
  }

  function sortGroups(groups, prioritiseAdults) {
    return groups.slice().sort(function (a, b) {
      if (prioritiseAdults) {
        var priority = classOrderIndex(a) - classOrderIndex(b);
        if (priority) return priority;
      }
      return a.name.localeCompare(b.name, 'en-GB');
    });
  }

  function isJuniorGroup(group) {
    return (group.minimumAge !== null && group.minimumAge < 18) ||
      group.levels.some(function (level) { return level.toLowerCase() === 'junior'; }) ||
      group.name.toLowerCase().includes('junior');
  }

  function isValidTime(value) {
    return typeof value === 'string' && /^([01]\d|2[0-3]):[0-5]\d$/.test(value.trim());
  }

  function oneHourLater(value) {
    var parts = String(value || '').split(':').map(Number);
    if (parts.length !== 2 || parts.some(Number.isNaN)) return '';
    return String((parts[0] + 1) % 24).padStart(2, '0') + ':' + String(parts[1]).padStart(2, '0');
  }

  function validateRecord(record) {
    if (!record || typeof record !== 'object') return null;
    var className = normaliseText(record.className);
    var day = normaliseText(record.day);
    var time = normaliseText(record.time);
    var canonicalDay = WEEKDAYS[DAY_INDEX[day.toLowerCase()]];
    if (!className || !canonicalDay || !isValidTime(time)) return null;

    var price = Number(record.price);
    var minimumAge = Number(record.minimumAge);
    return {
      className: className,
      day: canonicalDay,
      time: time,
      price: Number.isFinite(price) && price >= 0 ? price : null,
      level: normaliseText(record.level),
      minimumAge: Number.isFinite(minimumAge) && minimumAge >= 0 ? minimumAge : null,
      gender: normaliseText(record.gender)
    };
  }

  function validateResponse(data) {
    if (!data || data.ok !== true || !Array.isArray(data.classes)) {
      throw new Error('invalid-response');
    }
    MONDAY_BANK_HOLIDAY_DATES = new Set(
      Array.isArray(data.mondayBankHolidayDates) ?
        data.mondayBankHolidayDates.filter(function (date) {
          return /^\d{4}-\d{2}-\d{2}$/.test(String(date || ''));
        }) : []
    );
    return data.classes.map(validateRecord).filter(Boolean);
  }

  function fetchClasses(apiUrl, force) {
    if (force) API_CACHE.delete(apiUrl);
    if (!API_CACHE.has(apiUrl)) {
      API_CACHE.set(apiUrl, fetch(apiUrl, {
        method: 'GET',
        redirect: 'follow',
        credentials: 'omit'
      }).then(function (response) {
        if (!response.ok) throw new Error('request-failed');
        return response.json();
      }).then(validateResponse).catch(function (error) {
        API_CACHE.delete(apiUrl);
        throw error;
      }));
    }
    return API_CACHE.get(apiUrl);
  }

  function postBookingPayload(apiUrl, payload, retryCount) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    // Apps Script can occasionally need longer while Google commits the row.
    // Aborting at 15 seconds produced a false failure even though the booking
    // had been saved. Keep the idempotent retry, but allow the response to land.
    var timeout = controller ? window.setTimeout(function () { controller.abort(); }, 40000) : null;
    var retry = function () {
      if (retryCount >= 1) throw new Error('request-failed');
      return new Promise(function (resolve) {
        window.setTimeout(resolve, 800 * (retryCount + 1));
      }).then(function () { return postBookingPayload(apiUrl, payload, retryCount + 1); });
    };
    var request = fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
      redirect: 'follow',
      credentials: 'omit',
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('request-failed');
      return response.json();
    }).catch(function () {
      return retry();
    });
    return request.then(function (data) {
      var retryable = data && data.ok !== true &&
        (data.retryable === true || data.status === 'busy' || data.status === 'temporary-unavailable');
      if (retryable) return retry();
      return data;
    }).finally(function () {
      if (timeout) window.clearTimeout(timeout);
    });
  }

  function postQueuedBookingPayload(cloudflareUrl, payload) {
    var startedAt = Date.now();
    var admissionCompletedAt = 0;
    var statusUrl = cloudflareUrl + '/v1/booking/status';
    function parse(response) {
      if (!response.ok && response.status !== 202) throw new Error('request-failed');
      return response.json();
    }
    function poll() {
      if (Date.now() - startedAt > 90000) throw new Error('request-failed');
      return new Promise(function (resolve) { window.setTimeout(resolve, 700); })
        .then(function () {
          return fetch(statusUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ requestId: payload.requestId }), credentials: 'omit'
          });
        }).then(parse).then(function (data) {
          if (data && data.queued === true) return poll();
          if (data && typeof data === 'object') {
            data.performance = Object.assign({}, data.performance || {}, {
              browserAdmissionMs: Math.max(0, admissionCompletedAt - startedAt),
              browserWaitForCommitMs: Math.max(0, Date.now() - startedAt)
            });
          }
          return data;
        });
    }
    return fetch(cloudflareUrl + '/v1/booking/submit', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload), credentials: 'omit'
    }).then(parse).then(function (data) {
      admissionCompletedAt = Date.now();
      if (data && data.queued === true) return poll();
      if (data && typeof data === 'object') {
        data.performance = Object.assign({}, data.performance || {}, {
          browserAdmissionMs: admissionCompletedAt - startedAt,
          browserWaitForCommitMs: admissionCompletedAt - startedAt
        });
      }
      return data;
    });
  }

  function groupClasses(records) {
    var groups = new Map();
    records.forEach(function (record) {
      var key = record.className.toLocaleLowerCase('en-GB');
      if (!groups.has(key)) {
        groups.set(key, {
          key: key,
          name: record.className,
          price: record.price,
          minimumAge: record.minimumAge,
          levels: [],
          gender: record.gender,
          timetable: []
        });
      }
      var group = groups.get(key);
      if (group.price === null && record.price !== null) group.price = record.price;
      if (group.minimumAge === null && record.minimumAge !== null) group.minimumAge = record.minimumAge;
      if (!group.gender && record.gender) group.gender = record.gender;
      if (record.level && group.levels.indexOf(record.level) === -1) group.levels.push(record.level);
      if (!group.timetable.some(function (slot) {
        return slot.day === record.day && slot.time === record.time;
      })) {
        group.timetable.push({ day: record.day, time: record.time });
      }
    });

    return Array.from(groups.values()).map(function (group) {
      group.timetable.sort(function (a, b) {
        return DAY_INDEX[a.day.toLowerCase()] - DAY_INDEX[b.day.toLowerCase()] || a.time.localeCompare(b.time);
      });
      return group;
    }).sort(function (a, b) {
      return a.name.localeCompare(b.name, 'en-GB');
    });
  }

  function formatPrice(price) {
    if (price === null) return 'Price available at the club';
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: Number.isInteger(price) ? 0 : 2,
      maximumFractionDigits: 2
    }).format(price) + ' per class';
  }

  function formatMoney(price) {
    var amount = Number(price);
    if (!Number.isFinite(amount)) return '';
    return new Intl.NumberFormat('en-GB', {
      style: 'currency', currency: 'GBP',
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
      maximumFractionDigits: 2
    }).format(amount);
  }

  function displaySessionTime(time) {
    var match = String(time || '').match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return String(time || '');
    var hour = Number(match[1]);
    return (hour % 12 || 12) + ':' + match[2] + (hour >= 12 ? ' PM' : ' AM');
  }

  function maskEmail(email) {
    var parts = String(email || '').trim().split('@');
    if (parts.length !== 2 || !parts[0] || !parts[1]) return '';
    return parts[0].slice(0, 1) + '***@' + parts[1];
  }

  function timetableLabel(group) {
    return group.timetable.map(function (slot) {
      return slot.day.slice(0, 3) + ' ' + slot.time;
    }).join(' · ');
  }

  function londonDateParts(date) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: LONDON_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(date);
    var result = {};
    parts.forEach(function (part) {
      if (part.type !== 'literal') result[part.type] = Number(part.value);
    });
    return result;
  }

  function dateKey(year, month, day) {
    return [year, String(month).padStart(2, '0'), String(day).padStart(2, '0')].join('-');
  }

  function zonedDate(year, month, day, hour, minute) {
    var guess = Date.UTC(year, month - 1, day, hour, minute);
    var formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: LONDON_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    });

    for (var attempt = 0; attempt < 2; attempt += 1) {
      var parts = {};
      formatter.formatToParts(new Date(guess)).forEach(function (part) {
        if (part.type !== 'literal') parts[part.type] = Number(part.value);
      });
      var represented = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute);
      guess += Date.UTC(year, month - 1, day, hour, minute) - represented;
    }
    return new Date(guess);
  }

  function generateSessions(group) {
    var now = new Date();
    var bookingClosesAt = new Date(now.getTime() - 30 * 60 * 1000);
    var today = londonDateParts(now);
    var calendarStart = Date.UTC(today.year, today.month - 1, today.day, 12);
    var sessions = [];
    var seen = new Set();

    for (var offset = 0; offset <= 7; offset += 1) {
      var calendarDate = new Date(calendarStart + offset * 86400000);
      var weekday = WEEKDAYS[calendarDate.getUTCDay()];
      var calendarKey = dateKey(
        calendarDate.getUTCFullYear(),
        calendarDate.getUTCMonth() + 1,
        calendarDate.getUTCDate()
      );
      var bankHoliday = weekday === 'Monday' && MONDAY_BANK_HOLIDAY_DATES.has(calendarKey);
      var classKey = group.name.toLocaleLowerCase('en-GB');
      var bankHolidayTime = classKey === 'ladies only boxing' || classKey === 'ladies boxing' ? '10:00' :
        (classKey === 'punch bags' || classKey === 'punchbags' ? '12:00' :
        (classKey === 'thai boxing' || classKey === 'muay thai' ? '13:00' : ''));
      var timetable = bankHoliday ?
        (bankHolidayTime ? [{ day: 'Monday', time: bankHolidayTime }] : []) : group.timetable;
      timetable.forEach(function (slot) {
        if (slot.day !== weekday) return;
        var hourMinute = slot.time.split(':').map(Number);
        var instant = zonedDate(
          calendarDate.getUTCFullYear(),
          calendarDate.getUTCMonth() + 1,
          calendarDate.getUTCDate(),
          hourMinute[0],
          hourMinute[1]
        );
        var key = calendarKey + 'T' + slot.time;
        if (instant <= bookingClosesAt || seen.has(key)) return;
        seen.add(key);
        sessions.push({
          date: key.slice(0, 10),
          time: slot.time,
          instant: instant
        });
      });
    }
    return sessions.sort(function (a, b) { return a.instant - b.instant; });
  }

  function longDate(session) {
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: LONDON_ZONE,
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    }).format(session.instant);
  }

  function shortDate(session) {
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: LONDON_ZONE,
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    }).format(session.instant);
  }

  function deriveFilters(groups) {
    var definitions = [
      { id: 'all', label: 'All classes', test: function () { return true; } },
      { id: 'adults', label: 'Adults', test: function (group) { return !isJuniorGroup(group); } },
      { id: 'juniors', label: 'Juniors', test: isJuniorGroup },
      { id: 'ladies', label: 'Ladies', test: function (group) {
        return group.name.toLowerCase().includes('ladies') || group.gender.toLowerCase().includes('female');
      } },
      { id: 'beginner', label: 'Beginner-friendly', test: function (group) {
        return group.levels.some(function (level) { return level.toLowerCase().includes('beginner'); });
      } },
      { id: 'advanced', label: 'Advanced', test: function (group) {
        return group.levels.some(function (level) { return level.toLowerCase().includes('advanced'); });
      } }
    ];
    return definitions.filter(function (definition) {
      return definition.id === 'all' || groups.some(definition.test);
    });
  }

  var ADULT_WAIVER_PARAGRAPHS = [
    'I ASSUME ALL THE RISKS OF PARTICIPATING IN BOXING, FITNESS, CONTACT SPARRING OR ANY OTHER FORM OF PHYSICAL ACTIVITY offered by Heathrow Boxing Club. The coaches/staff/volunteers of Heathrow Boxing Club will not be liable for any injury or consequences that may arise from negligence or carelessness from the coaches /staff/volunteers instructing such activities including from dangerous or defective equipment or property owned, maintained, or controlled by them.',
    'I CERTIFY that I am physically fit to participate in the activities or events offered by Heathrow Boxing Club, and have not been advised to not participate by a qualified medical professional. I certify that there are no health-related reasons or problems, which preclude my participation in these programmes, activities, or events onsite / offsite the Heathrow Boxing Club premises.',
    'I ACKNOWLEDGE that I am fully required to provide my own medical coverage and that Heathrow Boxing Club will not be held liable for any expenses incurred for treatment of injuries while participating in these programmes, activities, or events.',
    'I HAVE READ, UNDERSTOOD & AGREE TO THIS DOCUMENT. I AM AWARE THAT THIS IS A RELEASE OF LIABILITY FORM.'
  ];

  function emptyAdultWaiver() {
    return {
      firstName: '', lastName: '', phone: '+44 ', address: '', dateOfBirth: '', email: '',
      postcode: '', addressVerified: false, medicalDeclaration: '', medicalConditionsOrInjuries: '', emergencyContactName: '',
      emergencyContactRelationship: '', emergencyContactNumber: '', signedName: '', attendedBefore: '',
      acquisitionSource: '', acquisitionSourceOther: '',
      marketingConsent: false, photoBase64: '', photoMimeType: '', photoFileName: '', photoPreview: '', agreement: false
    };
  }

  function emptyJuniorWaiver() {
    return {
      juniorFirstName: '', juniorLastName: '', juniorDateOfBirth: '', mobileContactNumber: '+44 ',
      email: '', address: '', postcode: '', addressVerified: false, medicalDeclaration: '', medicalConditionsOrInjuries: '',
      emergencyContactName: '', emergencyContactRelationship: '',
      emergencyContactNumber: '', juniorPronouns: '', promotionalPhotoConsent: '', attendedBefore: '',
      acquisitionSource: '', acquisitionSourceOther: '',
      signedByParentOrGuardian: '', photoBase64: '', photoMimeType: '',
      photoFileName: '', photoPreview: '', marketingConsent: false, agreement: false
    };
  }

  function normalisedName(value) {
    return normaliseText(value).toLowerCase();
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function validUkMobile(value) {
    var compact = value.replace(/[\s()-]/g, '');
    var national = compact.replace(/^(?:\+44|0044)/, '0');
    return /^07\d{9}$/.test(national) && !/(\d)\1{7,}/.test(national);
  }

  function displayUkMobile(value) {
    var compact = String(value || '').replace(/[\s()-]/g, '');
    if (/^07\d*$/.test(compact)) return '+44 ' + compact.slice(1);
    if (/^0044/.test(compact)) return '+44 ' + compact.slice(4);
    if (/^\+44/.test(compact)) return '+44 ' + compact.slice(3);
    return value || '+44 ';
  }

  function validUkPhone(value) {
    var compact = value.replace(/[\s()-]/g, '');
    var national = compact.replace(/^(?:\+44|0044)/, '0');
    return /^0\d{9,10}$/.test(national) && !/(\d)\1{7,}/.test(national);
  }

  function validUkPostcode(value) {
    return /^(GIR 0AA|[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2})$/i.test(value);
  }

  function meaningfulPersonName(value, fullName) {
    var text = normaliseText(value);
    var letters;
    var validCharacters;
    try {
      letters = text.replace(/[^\p{L}\p{M}]/gu, '');
      validCharacters = /^[\p{L}\p{M}][\p{L}\p{M} '\-\u2019]{1,79}$/u.test(text);
    } catch (ignored) {
      var comparable = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      letters = comparable.replace(/[^A-Za-z]/g, '');
      validCharacters = /^[A-Za-z][A-Za-z '\-]{1,79}$/.test(comparable);
    }
    if (letters.length < 2 || /^(.)\1+$/i.test(letters)) return false;
    if (!validCharacters) return false;
    return !fullName || text.split(/\s+/).filter(Boolean).length >= 2;
  }

  function meaningfulAddress(value) {
    var text = normaliseText(value);
    var letters = text.replace(/[^A-Za-z]/g, '');
    return text.length >= 8 && letters.length >= 4 &&
      !/^(?:n\/?a|none|unknown|no address|not applicable)$/i.test(text) &&
      !/^(.)\1+$/.test(text);
  }

  function validRelationship(value) {
    return ['parent', 'guardian', 'spouse', 'partner', 'sibling', 'relative',
      'friend', 'carer', 'other'].indexOf(String(value || '').toLowerCase()) !== -1;
  }

  function savedBookingDetails() {
    try {
      var saved = JSON.parse(window.localStorage.getItem(SAVED_DETAILS_KEY) || 'null');
      if (!saved || Date.now() - Number(saved.savedAt || 0) > SAVED_DETAILS_MAX_AGE) {
        window.localStorage.removeItem(SAVED_DETAILS_KEY);
        return null;
      }
      return saved;
    } catch (error) {
      return null;
    }
  }

  function rememberBookingDetails(details) {
    try {
      window.localStorage.setItem(SAVED_DETAILS_KEY, JSON.stringify({
        firstName: normaliseText(details.firstName),
        lastName: normaliseText(details.lastName),
        phone: normaliseText(details.phone),
        email: normaliseText(details.email),
        savedAt: Date.now()
      }));
    } catch (error) {
      // Browser privacy settings may disable storage; native autocomplete still works.
    }
  }

  function ageOnDate(dateOfBirth, targetDate) {
    var birth = new Date(dateOfBirth + 'T00:00:00');
    var target = new Date(targetDate + 'T00:00:00');
    var age = target.getFullYear() - birth.getFullYear();
    if (target.getMonth() < birth.getMonth() ||
      (target.getMonth() === birth.getMonth() && target.getDate() < birth.getDate())) age -= 1;
    return age;
  }

  function juniorLatestEligibleBirthDate() {
    var today = new Date();
    var eligible = new Date(today.getFullYear() - 11, today.getMonth(), today.getDate());
    return eligible.getFullYear() + '-' + String(eligible.getMonth() + 1).padStart(2, '0') + '-' +
      String(eligible.getDate()).padStart(2, '0');
  }

  function juniorEarliestEligibleBirthDate() {
    var today = new Date();
    var eligible = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate() + 1);
    return eligible.getFullYear() + '-' + String(eligible.getMonth() + 1).padStart(2, '0') + '-' +
      String(eligible.getDate()).padStart(2, '0');
  }

  function adultLatestEligibleBirthDate() {
    var today = new Date();
    var eligible = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    return eligible.getFullYear() + '-' + String(eligible.getMonth() + 1).padStart(2, '0') + '-' +
      String(eligible.getDate()).padStart(2, '0');
  }

  function HbcBooking(root) {
    this.root = root;
    this.mode = root.dataset.mode;
    this.context = root.dataset.bookingContext || 'booking';
    this.apiUrl = root.dataset.apiUrl;
    this.cloudflareUrl = String(root.dataset.cloudflareUrl || '').replace(/\/+$/, '');
    this.timetableApiUrl = root.dataset.timetableApiUrl || DEFAULT_TIMETABLE_API_URL;
    this.cardLimit = Number(root.dataset.cardLimit) || 4;
    this.filtersEnabled = root.dataset.filtersEnabled === 'true';
    this.primaryLabel = root.dataset.primaryLabel || 'Book';
    this.groups = [];
    this.filter = 'all';
    this.filters = [];
    this.selectedClass = null;
    this.sessions = [];
    this.selectedSession = null;
    var remembered = savedBookingDetails() || {};
    this.details = {
      firstName: remembered.firstName || '',
      lastName: remembered.lastName || '',
      phone: displayUkMobile(remembered.phone),
      email: remembered.email || '',
      attendedBefore: ''
    };
    this.customerStatus = '';
    this.preStage = 'booking';
    this.waiver = null;
    this.waiverId = '';
    this.waiverQrToken = '';
    this.waiverError = '';
    this.waiverAttemptId = '';
    this.waiverValidationErrors = {};
    this.photoPreparationId = 0;
    this.photoPreparing = false;
    this.bookingAttemptId = '';
    this.customerProfile = null;
    this.lookupSignature = '';
    this.lookupCompleteSignature = '';
    this.lookupPending = false;
    this.lookupPromise = null;
    this.lookupState = 'idle';
    this.lookupTimer = null;
    this.addressLookupTimer = null;
    this.addressLookupRequest = 0;
    this.addressLookupController = null;
    this.addressSessionToken = window.crypto && typeof window.crypto.randomUUID === 'function' ?
      window.crypto.randomUUID() : 'hbc-address-' + Date.now() + '-' + Math.random().toString(36).slice(2);
    this.step = 1;
    this.submitting = false;
    this.processingStartedAt = 0;
    this.processingProgressTimer = null;
    this.processingCompletionPending = false;
    this.processingCompletionInFlight = false;
    this.bookingWaitLong = false;
    this.bookingWaitTimer = null;
    this.success = null;
    this.trigger = null;
    this.modalOpen = false;
    this.journey = 'group';
    this.personalStage = 'personal-intro';
    this.personalPlan = emptyOneToOnePlan();
    this.personalAvailability = [];
    this.personalCalendarDays = [];
    this.personalAvailabilityLoaded = false;
    this.personalCalendarDate = '';
    this.personalError = '';
    this.cancellationAccepted = false;
    this.membershipStage = 'membership-intro';
    this.membershipError = '';
    this.pageScrollY = 0;
    this.bodyStyleBeforeModal = null;
    this.boundKeydown = this.onKeydown.bind(this);
    this.bind();
    this.observeAnalyticsView();
    if (this.context === 'standalone') this.handleDirectWaiverLink();
    else {
      this.load(false);
      this.handleDirectServiceLink();
    }
  }

  HbcBooking.prototype.observeAnalyticsView = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      trackBookingEvent(self, 'booking_widget_viewed');
    }, { threshold: 0.2 });
    observer.observe(this.root);
  };

  HbcBooking.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (event) {
      var action = event.target.closest('[data-booking-action]');
      var close = event.target.closest('[data-booking-close]');
      var retry = event.target.closest('[data-booking-retry]');
      var filter = event.target.closest('[data-booking-filter]');
      var classChoice = event.target.closest('[data-class-key]');
      var sessionChoice = event.target.closest('[data-session-key]');
      var standaloneWaiver = event.target.closest('[data-standalone-waiver]');
      var personalOpen = event.target.closest('[data-one-to-one-open]');
      var membershipOpen = event.target.closest('[data-membership-open]');
      var personalChoice = event.target.closest('[data-personal-choice]');
      var addressSuggestion = event.target.closest('[data-address-suggestion]');

      if (addressSuggestion) return self.selectAddressSuggestion(addressSuggestion);
      if (close) return self.closeModal();
      if (personalOpen) return self.openOneToOne(personalOpen);
      if (membershipOpen) return self.openMembership(membershipOpen);
      if (personalChoice) return self.selectPersonalChoice(personalChoice);
      if (standaloneWaiver) return self.openStandaloneWaiver(standaloneWaiver.dataset.standaloneWaiver, standaloneWaiver);
      if (retry) return self.load(true);
      if (filter) {
        self.filter = filter.dataset.bookingFilter;
        self.renderFilters();
        self.renderCards();
        return;
      }
      if (classChoice) return self.selectClass(classChoice.dataset.classKey, classChoice);
      if (sessionChoice) {
        self.selectedSession = self.sessions.find(function (session) {
          return session.date + 'T' + session.time === sessionChoice.dataset.sessionKey;
        }) || null;
        self.bookingAttemptId = '';
        if (self.selectedSession) self.step = 3;
        if (self.selectedSession) {
          trackBookingEvent(self, 'session_selected');
          trackBookingEvent(self, 'details_started');
        }
        self.renderFlow();
        var firstDetailsInput = self.root.querySelector('[data-booking-field]');
        if (firstDetailsInput) firstDetailsInput.focus();
        return;
      }
      if (!action) return;
      self.handleAction(action.dataset.bookingAction, action);
    });

    this.root.addEventListener('input', function (event) {
      if (event.target.matches('[data-waiver-field]')) {
        var key = event.target.dataset.waiverField;
        self.waiver[key] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        if (key === 'postcode') {
          self.waiver[key] = self.waiver[key].toUpperCase();
          event.target.value = self.waiver[key];
        }
        if (key === 'address' && event.target.matches('[data-address-lookup]')) {
          self.waiver.addressVerified = false;
          var postcodeField = self.root.querySelector('[data-waiver-wrapper="postcode"]');
          if (postcodeField) postcodeField.hidden = false;
          event.target.classList.remove('is-address-selected');
          var addressHelp = self.root.querySelector('[data-address-help]');
          if (addressHelp) {
            addressHelp.textContent = 'Choose an address from the suggestions. If it is not listed, type the complete address manually.';
            addressHelp.classList.remove('is-selected');
          }
          window.clearTimeout(self.addressLookupTimer);
          self.addressLookupTimer = window.setTimeout(function () {
            self.searchAddresses(event.target.value, event.target);
          }, 300);
        }
        event.target.removeAttribute('aria-invalid');
        var waiverError = self.root.querySelector('[data-waiver-error-for="' + key + '"]');
        if (waiverError) waiverError.textContent = '';
        if (self.waiverValidationErrors) delete self.waiverValidationErrors[key];
        if (key === 'attendedBefore' && self.waiver.attendedBefore !== 'no') {
          self.waiver.acquisitionSource = '';
          self.waiver.acquisitionSourceOther = '';
          delete self.waiverValidationErrors.acquisitionSource;
          delete self.waiverValidationErrors.acquisitionSourceOther;
        }
        if (key === 'acquisitionSource' && self.waiver.acquisitionSource !== 'other') {
          self.waiver.acquisitionSourceOther = '';
          delete self.waiverValidationErrors.acquisitionSourceOther;
        }
        if (key === 'medicalDeclaration' && self.waiver.medicalDeclaration !== 'yes') {
          self.waiver.medicalConditionsOrInjuries = '';
          delete self.waiverValidationErrors.medicalConditionsOrInjuries;
        }
        self.updateWaiverValidationSummary();
        if (key === 'juniorFirstName' || key === 'juniorLastName' ||
          key === 'juniorPronouns' || key === 'promotionalPhotoConsent') {
          self.updateJuniorAgreementText();
        }
        self.updateWaiverSubmitState();
        return;
      }
      if (event.target.matches('[data-personal-field]')) {
        var personalKey = event.target.dataset.personalField;
        if (personalKey === 'cancellationAccepted') {
          self.cancellationAccepted = event.target.checked;
          self.renderFlow();
          return;
        }
        self.personalPlan[personalKey] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        return;
      }
      if (!event.target.matches('[data-booking-field]')) return;
      self.details[event.target.dataset.bookingField] = event.target.value;
      self.customerProfile = null;
      self.lookupSignature = '';
      self.lookupCompleteSignature = '';
      self.lookupState = 'idle';
      self.updateMemberDisplay();
      event.target.removeAttribute('aria-invalid');
      var error = self.root.querySelector('[data-error-for="' + event.target.dataset.bookingField + '"]');
      if (error) error.textContent = '';
      if (!isJuniorGroup(self.selectedClass)) {
        window.clearTimeout(self.lookupTimer);
        self.lookupTimer = window.setTimeout(function () { self.lookupCustomer(); }, 450);
      }
    });

    this.root.addEventListener('change', function (event) {
      if (event.target.matches('[data-waiver-field="attendedBefore"], [data-waiver-field="acquisitionSource"], [data-waiver-field="medicalDeclaration"]')) {
        self.renderWaiverConditionalFields(event.target.dataset.waiverField);
        return;
      }
      if (event.target.matches('[data-personal-calendar-date]')) {
        self.personalCalendarDate = event.target.value;
        self.renderFlow();
        return;
      }
      if (!event.target.matches('[data-waiver-photo]')) return;
      self.handleWaiverPhoto(event.target.files && event.target.files[0], event.target);
    });

    this.root.addEventListener('focusout', function (event) {
      if (!event.target.matches('[data-booking-field]')) return;
      if (isJuniorGroup(self.selectedClass)) return;
      window.clearTimeout(self.lookupTimer);
      self.lookupTimer = window.setTimeout(function () { self.lookupCustomer(); }, 120);
    });

  };

  HbcBooking.prototype.renderWaiverConditionalFields = function (fieldKey) {
    var container = this.root.querySelector('[data-booking-flow]');
    var pageTop = window.scrollY || window.pageYOffset || 0;
    var scrollTop = container ? container.scrollTop : 0;
    this.renderFlow();
    var replacement = this.root.querySelector('[data-waiver-field="' + fieldKey + '"]');
    if (container) container.scrollTop = scrollTop;
    window.scrollTo(0, pageTop);
    if (replacement && replacement.focus) {
      try { replacement.focus({ preventScroll: true }); } catch (error) { replacement.focus(); }
    }
  };

  HbcBooking.prototype.load = function (force) {
    var self = this;
    this.showLoadState('loading');
    fetchClasses(this.timetableApiUrl, force).then(function (records) {
      self.groups = groupClasses(records);
      self.filters = deriveFilters(self.groups);
      self.showLoadState(self.groups.length ? 'loaded' : 'empty');
      self.renderFilters();
      self.renderCards();
    }).catch(function () {
      self.showLoadState('error');
    });
  };

  HbcBooking.prototype.showLoadState = function (state) {
    var status = this.root.querySelector('[data-booking-status]');
    var cards = this.root.querySelector('[data-booking-classes]');
    var filters = this.root.querySelector('[data-booking-filters]');
    var empty = this.root.querySelector('[data-booking-empty]');
    var error = this.root.querySelector('[data-booking-load-error]');
    status.hidden = state !== 'loading';
    cards.hidden = state !== 'loaded';
    filters.hidden = state !== 'loaded' || this.mode !== 'full' || !this.filtersEnabled;
    empty.hidden = state !== 'empty';
    error.hidden = state !== 'error';
  };

  HbcBooking.prototype.renderFilters = function () {
    var self = this;
    var container = this.root.querySelector('[data-booking-filters]');
    container.replaceChildren();
    this.filters.forEach(function (filter) {
      var button = element('button', 'hbc-booking__filter', filter.label);
      button.type = 'button';
      button.dataset.bookingFilter = filter.id;
      button.setAttribute('aria-pressed', String(self.filter === filter.id));
      container.appendChild(button);
    });
  };

  HbcBooking.prototype.filteredGroups = function () {
    var filter = this.filters.find(function (item) { return item.id === this.filter; }, this);
    var groups = filter ? this.groups.filter(filter.test) : this.groups;
    return sortGroups(groups, this.filter === 'adults');
  };

  HbcBooking.prototype.renderCards = function () {
    var self = this;
    var container = this.root.querySelector('[data-booking-classes]');
    var groups = this.filteredGroups();
    container.replaceChildren();
    groups.forEach(function (group) {
      var card = element('article', 'hbc-booking__card');
      var title = element('h3', 'hbc-booking__card-heading', group.name);
      var meta = element('div', 'hbc-booking__card-meta');
      group.levels.forEach(function (level) {
        meta.appendChild(element('span', 'hbc-booking__tag', level));
      });
      if (group.minimumAge !== null || isJuniorGroup(group)) {
        meta.appendChild(element('span', 'hbc-booking__tag', 'Ages ' +
          (isJuniorGroup(group) ? 11 : group.minimumAge) + '+'));
      }
      var price = element('p', 'hbc-booking__price', formatPrice(group.price));
      var schedule = element('p', 'hbc-booking__schedule', timetableLabel(group));
      var button = element('button', 'hbc-booking__button', self.primaryLabel + ' ' + group.name);
      button.type = 'button';
      button.dataset.classKey = group.key;
      card.append(title, meta, price, schedule);
      if (isJuniorGroup(group)) {
        card.appendChild(element('p', 'hbc-booking__junior-age-notice',
          'Junior participants must be aged 11 or older.'));
      }
      var className = normaliseText(group.name).toLowerCase();
      if (className === 'pads') {
        card.appendChild(element('p', 'hbc-booking__class-requirement',
          'Intermediate class: prior pad-holding experience and a high level of fitness are required.'));
      } else if (className === 'sparring') {
        card.appendChild(element('p', 'hbc-booking__class-requirement hbc-booking__class-requirement--advanced',
          'Advanced class: very high fitness, strong boxing fundamentals and substantial boxing experience are required.'));
      }
      card.appendChild(button);
      container.appendChild(card);
    });
  };

  HbcBooking.prototype.selectClass = function (key, trigger) {
    this.journey = 'group';
    var dialogTitle = this.root.querySelector('[id^="hbc-booking-dialog-title-"]');
    if (dialogTitle) dialogTitle.textContent = 'Book a class';
    this.selectedClass = this.groups.find(function (group) { return group.key === key; }) || null;
    if (!this.selectedClass) return;
    trackBookingEvent(this, 'class_selected');
    if (!this.details.firstName && !this.details.lastName && !this.details.phone && !this.details.email) {
      var remembered = savedBookingDetails() || {};
      this.details = {
        firstName: remembered.firstName || '', lastName: remembered.lastName || '',
        phone: displayUkMobile(remembered.phone), email: remembered.email || '', attendedBefore: ''
      };
    }
    this.sessions = generateSessions(this.selectedClass);
    this.selectedSession = null;
    this.success = null;
    this.step = 2;
    this.customerStatus = '';
    this.preStage = 'booking';
    this.waiver = null;
    this.waiverId = '';
    this.waiverQrToken = '';
    this.waiverError = '';
    this.waiverAttemptId = '';
    this.waiverValidationErrors = {};
    this.photoPreparationId += 1;
    this.photoPreparing = false;
    this.bookingAttemptId = '';
    this.customerProfile = null;
    this.lookupSignature = '';
    this.lookupCompleteSignature = '';
    if (!this.modalOpen) this.trigger = trigger;
    if (this.mode === 'compact') this.openModal();
    else {
      this.root.querySelector('[data-booking-flow]').hidden = false;
      this.renderFlow();
      this.root.querySelector('[data-booking-flow]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  HbcBooking.prototype.openModal = function () {
    var modal = this.root.querySelector('[data-booking-modal]');
    this.modalOpen = true;
    this.root.classList.add('is-modal-open');
    modal.hidden = false;
    this.lockPageScroll();
    document.addEventListener('keydown', this.boundKeydown);
    this.renderFlow();
    var dialog = modal.querySelector('[role="dialog"]');
    window.requestAnimationFrame(function () { dialog.focus(); });
  };

  HbcBooking.prototype.closeModal = function () {
    if (!this.modalOpen || this.submitting) return;
    var modal = this.root.querySelector('[data-booking-modal]');
    modal.hidden = true;
    this.modalOpen = false;
    this.root.classList.remove('is-modal-open');
    this.unlockPageScroll();
    document.removeEventListener('keydown', this.boundKeydown);
    if (this.trigger) this.trigger.focus();
    this.clearSensitiveState();
  };

  HbcBooking.prototype.lockPageScroll = function () {
    if (this.bodyStyleBeforeModal) return;
    this.pageScrollY = window.scrollY || window.pageYOffset || 0;
    this.bodyStyleBeforeModal = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      overflow: document.body.style.overflow
    };
    document.body.classList.add('hbc-booking-modal-open');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + this.pageScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  };

  HbcBooking.prototype.unlockPageScroll = function () {
    if (!this.bodyStyleBeforeModal) return;
    var previous = this.bodyStyleBeforeModal;
    document.body.classList.remove('hbc-booking-modal-open');
    document.body.style.position = previous.position;
    document.body.style.top = previous.top;
    document.body.style.left = previous.left;
    document.body.style.right = previous.right;
    document.body.style.width = previous.width;
    document.body.style.overflow = previous.overflow;
    this.bodyStyleBeforeModal = null;
    window.scrollTo(0, this.pageScrollY);
  };

  HbcBooking.prototype.onKeydown = function (event) {
    if (!this.modalOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeModal();
      return;
    }
    if (event.key !== 'Tab') return;
    var dialog = this.root.querySelector('[role="dialog"]');
    var focusable = Array.from(dialog.querySelectorAll(FOCUSABLE)).filter(function (node) {
      return node.offsetParent !== null;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  HbcBooking.prototype.handleAction = function (action, actionButton) {
    if (action.indexOf('personal-') === 0) return this.handlePersonalAction(action);
    if (action.indexOf('membership-') === 0) return this.handleMembershipAction(action);
    if (action === 'back-booking-details') {
      this.preStage = 'booking';
      this.step = 3;
      this.renderFlow();
    } else if (action === 'submit-waiver') {
      this.submitWaiver();
    } else if (action === 'waiver-error-close') {
      this.waiverError = '';
      this.renderFlow();
    } else if (action === 'waiver-fix-first') {
      this.focusFirstWaiverIssue();
    } else if (action === 'waiver-cancel-booking') {
      this.waiverError = '';
      this.closeModal();
    } else if (action === 'standalone-back' || action === 'standalone-done') {
      this.closeModal();
    } else if (action === 'continue-after-waiver') {
      this.preStage = 'booking';
      this.renderFlow();
    } else if (action === 'back-classes') {
      this.step = 1;
      this.selectedClass = null;
      this.selectedSession = null;
      this.renderFlow();
    } else if (action === 'back-sessions') {
      this.step = 2;
      this.renderFlow();
    } else if (action === 'continue-details' && this.selectedSession) {
      this.step = 3;
      this.renderFlow();
      var firstInput = this.root.querySelector('[data-booking-field]');
      if (firstInput) firstInput.focus();
    } else if (action === 'submit') {
      this.submit();
    } else if (action === 'book-another') {
      this.resetFlow();
    } else if (action === 'save-qr') {
      this.saveQr(actionButton);
    } else if (action === 'close-success') {
      this.closeModal();
    }
  };

  HbcBooking.prototype.saveQr = function (button) {
    var image = this.root.querySelector('[data-booking-qr-image]');
    if (!image || !image.src || !button) return;
    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Saving…';
    fetch(image.src).then(function (response) {
      if (!response.ok) throw new Error('qr-download-failed');
      return response.blob();
    }).then(function (blob) {
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = 'HBC-permanent-QR.png';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
      button.textContent = 'QR saved';
    }).catch(function () {
      window.open(image.src, '_blank', 'noopener');
      button.textContent = 'QR opened';
    }).finally(function () {
      window.setTimeout(function () {
        button.disabled = false;
        button.textContent = original;
      }, 1800);
    });
  };

  HbcBooking.prototype.progress = function () {
    if (this.journey === 'one-to-one' && this.preStage === 'booking') return this.personalProgress();
    if (this.journey === 'membership' && this.preStage === 'booking') return this.membershipProgress();
    if (this.preStage !== 'booking') {
      var preProgress = element('ol', 'hbc-booking__progress hbc-booking__progress--pre');
      var current = this.preStage === 'customer-status' ? 1 : (this.preStage === 'waiver-success' ? 3 : 2);
      var preLabels = this.context === 'standalone' ?
        ['Choose waiver', 'Complete form', 'Done'] :
        ['First visit', 'Waiver', 'Book class'];
      preLabels.forEach(function (label, index) {
        var item = element('li', index + 1 < current ? 'is-complete' : '', (index + 1) + '. ' + label);
        if (index + 1 === current) item.setAttribute('aria-current', 'step');
        preProgress.appendChild(item);
      });
      return preProgress;
    }
    var labels = ['Choose class', 'Choose session', 'Your details', 'Confirmation'];
    var list = element('ol', 'hbc-booking__progress');
    if (this.success) list.classList.add('hbc-booking__progress--complete');
    labels.forEach(function (label, index) {
      var item = element('li', index < this.step - 1 ? 'is-complete' : '', (index + 1) + '. ' + label);
      if (index === this.step - 1) item.setAttribute('aria-current', 'step');
      list.appendChild(item);
    }, this);
    return list;
  };

  HbcBooking.prototype.renderFlow = function () {
    var container = this.root.querySelector('[data-booking-flow]');
    if (!container) return;
    if (this.processingCompletionPending) {
      var self = this;
      this.processingCompletionPending = false;
      this.processingCompletionInFlight = true;
      this.completeProcessingOverlay();
      window.setTimeout(function () {
        self.processingCompletionInFlight = false;
        self.processingStartedAt = 0;
        self.renderFlow();
        if (self.success || self.preStage === 'waiver-success') self.revealQrResult();
      }, 320);
      return;
    }
    if (this.processingCompletionInFlight) return;
    this.stopProcessingProgress();
    container.replaceChildren();
    container.setAttribute('aria-busy', this.submitting ? 'true' : 'false');
    var flow = element('div', 'hbc-booking__flow');
    flow.appendChild(this.progress());
    if (this.preStage === 'adult-waiver') flow.appendChild(this.renderAdultWaiverForm());
    else if (this.preStage === 'junior-waiver') flow.appendChild(this.renderJuniorWaiverForm());
    else if (this.preStage === 'waiver-success') flow.appendChild(this.renderWaiverSuccess());
    else if (this.journey === 'one-to-one') flow.appendChild(this.renderPersonalFlow());
    else if (this.journey === 'membership') flow.appendChild(this.renderMembershipFlow());
    else if (this.success) flow.appendChild(this.renderSuccess());
    else if (this.step === 1) flow.appendChild(this.renderClassStep());
    else if (this.step === 2) flow.appendChild(this.renderSessionStep());
    else flow.appendChild(this.renderDetailsStep());
    if (this.submitting) flow.appendChild(this.renderProcessingOverlay());
    else if (this.waiverError &&
      (this.preStage === 'adult-waiver' || this.preStage === 'junior-waiver')) {
      flow.appendChild(this.renderWaiverFailureOverlay());
    }
    container.appendChild(flow);
    container.scrollTop = 0;
  };

  HbcBooking.prototype.stopProcessingProgress = function () {
    if (!this.processingProgressTimer) return;
    window.clearInterval(this.processingProgressTimer);
    this.processingProgressTimer = null;
  };

  HbcBooking.prototype.completeProcessingOverlay = function () {
    this.stopProcessingProgress();
    var overlay = this.root.querySelector('.hbc-booking__processing');
    if (!overlay) return;
    var fill = overlay.querySelector('[data-processing-progress-fill]');
    var value = overlay.querySelector('[data-processing-progress-value]');
    var stage = overlay.querySelector('[data-processing-progress-stage]');
    if (fill) fill.style.width = '100%';
    if (value) value.textContent = '100%';
    if (stage) stage.textContent = 'Complete';
    overlay.classList.add('is-complete');
  };

  HbcBooking.prototype.revealQrResult = function () {
    var self = this;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        var target = self.success ? self.root.querySelector('[data-qr-result]') :
          (self.root.querySelector('[data-qr-image-result]') ||
            self.root.querySelector('[data-qr-result]'));
        if (!target) return;
        var active = document.activeElement;
        if (active && typeof active.blur === 'function') active.blur();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var heading = self.root.querySelector('[data-qr-result-heading]');
        if (!heading) return;
        heading.setAttribute('tabindex', '-1');
        try { heading.focus({ preventScroll: true }); } catch (error) { heading.focus(); }
      });
    });
  };

  HbcBooking.prototype.renderProcessingOverlay = function () {
    var self = this;
    var savingWaiver = this.preStage === 'adult-waiver' || this.preStage === 'junior-waiver';
    var title = 'Confirming your booking';
    var copy = 'We are securely reserving your place and preparing your confirmation.';
    if (savingWaiver) {
      title = 'Saving your waiver';
      copy = 'We are securely saving your details and identification photograph.';
    } else if (this.journey === 'membership') {
      title = 'Reserving your membership';
      copy = 'We are securely checking your details and recording your reservation.';
    } else if (this.journey === 'one-to-one') {
      title = 'Confirming your session';
      copy = 'We are securely recording your one-to-one coaching request.';
    } else if (this.bookingWaitLong) {
      title = 'Almost there';
      copy = 'Your place is still being safely confirmed. Keep this window open—one booking only will be created.';
    }
    var overlay = element('div', 'hbc-booking__processing');
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-live', 'polite');
    overlay.setAttribute('aria-atomic', 'true');
    var panel = element('div', 'hbc-booking__processing-panel');
    var spinner = element('span', 'hbc-booking__processing-spinner');
    spinner.setAttribute('aria-hidden', 'true');
    var label = element('p', 'hbc-booking__processing-eyebrow', 'Please wait');
    var heading = element('h3', 'hbc-booking__processing-title', title);
    var description = element('p', 'hbc-booking__processing-copy', copy);
    var warning = element('p', 'hbc-booking__processing-warning', 'Please do not refresh, close this page or press the button again.');
    var progress = element('div', 'hbc-booking__processing-progress');
    progress.setAttribute('role', 'progressbar');
    progress.setAttribute('aria-label', title + ' progress');
    progress.setAttribute('aria-valuemin', '0');
    progress.setAttribute('aria-valuemax', '100');
    var progressMeta = element('div', 'hbc-booking__processing-progress-meta');
    var progressStage = element('span', '', 'Securing your details');
    progressStage.dataset.processingProgressStage = '';
    var progressValue = element('strong', '', '8%');
    progressValue.dataset.processingProgressValue = '';
    progressMeta.append(progressStage, progressValue);
    var progressTrack = element('span', 'hbc-booking__processing-progress-track');
    var progressFill = element('span', 'hbc-booking__processing-progress-fill');
    progressFill.dataset.processingProgressFill = '';
    progressTrack.appendChild(progressFill);
    progress.append(progressMeta, progressTrack);
    var dots = element('span', 'hbc-booking__processing-dots');
    dots.setAttribute('aria-hidden', 'true');
    dots.append(element('i'), element('i'), element('i'));
    panel.append(spinner, label, heading, description, progress, warning, dots);
    overlay.appendChild(panel);
    if (!this.processingStartedAt) this.processingStartedAt = Date.now();
    function updateProgress() {
      var elapsed = Math.max(0, Date.now() - self.processingStartedAt);
      var percent = Math.min(94, Math.round(8 + 86 * (1 - Math.exp(-elapsed / 5000))));
      progressFill.style.width = percent + '%';
      progressValue.textContent = percent + '%';
      progress.setAttribute('aria-valuenow', String(percent));
      progressStage.textContent = percent < 55 ? 'Securing your details' :
        (percent < 82 ? 'Waiting for confirmation' : 'Completing final checks');
    }
    updateProgress();
    this.stopProcessingProgress();
    this.processingProgressTimer = window.setInterval(updateProgress, 250);
    return overlay;
  };

  HbcBooking.prototype.renderWaiverFailureOverlay = function () {
    var missingWaiver = /no matching online waiver|waiver not found/i.test(this.waiverError || '');
    var overlay = element('div', 'hbc-booking__processing ' +
      (missingWaiver ? 'hbc-booking__processing--waiver-prompt' : 'hbc-booking__processing--error'));
    overlay.setAttribute('role', 'alertdialog');
    overlay.setAttribute('aria-modal', 'true');
    var panel = element('div', 'hbc-booking__processing-panel');
    var icon = element('span', missingWaiver ? 'hbc-booking__processing-waiver-icon' :
      'hbc-booking__processing-error-icon', missingWaiver ? '✓' : '!');
    icon.setAttribute('aria-hidden', 'true');
    var label = element('p', 'hbc-booking__processing-eyebrow',
      missingWaiver ? 'One quick step' : 'Waiver not saved');
    var heading = element('h3', 'hbc-booking__processing-title',
      missingWaiver ? 'You’re almost there' : 'Please try again');
    var description = element('p', 'hbc-booking__processing-copy', missingWaiver ?
      'We just need you to sign our online waiver before we can confirm your place.' :
      this.waiverError);
    var warning = element('p', 'hbc-booking__processing-warning', missingWaiver ?
      'It only takes a few minutes and you normally only need to complete it once.' :
      'Your information and selected photograph are still here. No duplicate waiver will be created.');
    var actions = element('div', 'hbc-booking__processing-actions');
    var back = element('button', 'hbc-booking__button',
      missingWaiver ? 'Sign waiver' : 'Review form');
    back.type = 'button';
    back.dataset.bookingAction = 'waiver-error-close';
    var retry = element('button', 'hbc-booking__button', 'Try saving again');
    retry.type = 'button';
    retry.dataset.bookingAction = 'submit-waiver';
    actions.appendChild(back);
    if (missingWaiver) {
      var cancel = element('button', 'hbc-booking__button hbc-booking__button--secondary', 'Cancel booking');
      cancel.type = 'button';
      cancel.dataset.bookingAction = 'waiver-cancel-booking';
      actions.appendChild(cancel);
    } else actions.appendChild(retry);
    panel.append(icon, label, heading, description, warning, actions);
    overlay.appendChild(panel);
    return overlay;
  };

  HbcBooking.prototype.openStandaloneWaiver = function (type, trigger) {
    if (type !== 'adult' && type !== 'junior') return;
    this.trigger = trigger || this.root.querySelector('[data-standalone-waiver="' + type + '"]');
    this.selectedClass = type === 'junior' ?
      { name: 'Junior waiver', minimumAge: 11, levels: ['Junior'] } :
      { name: 'Adult waiver', minimumAge: 18, levels: ['Adult'] };
    this.sessions = [];
    this.selectedSession = null;
    this.customerStatus = 'new';
    this.waiver = type === 'junior' ? emptyJuniorWaiver() : emptyAdultWaiver();
    this.waiverId = '';
    this.waiverQrToken = '';
    this.waiverError = '';
    this.waiverAttemptId = '';
    this.waiverValidationErrors = {};
    this.photoPreparationId += 1;
    this.photoPreparing = false;
    this.success = null;
    this.preStage = type === 'junior' ? 'junior-waiver' : 'adult-waiver';
    this.openModal();
  };

  HbcBooking.prototype.handleDirectWaiverLink = function () {
    var type = new URLSearchParams(window.location.search).get('waiver');
    if (type !== 'adult' && type !== 'junior') return;
    var self = this;
    window.requestAnimationFrame(function () {
      self.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      self.openStandaloneWaiver(type);
    });
  };

  HbcBooking.prototype.handleDirectServiceLink = function () {
    var service = new URLSearchParams(window.location.search).get('service');
    if (service !== 'one-to-one' && service !== 'membership') return;
    var self = this;
    window.requestAnimationFrame(function () {
      self.root.scrollIntoView({ behavior: 'auto', block: 'start' });
      if (service === 'one-to-one') self.openOneToOne(self.root.querySelector('[data-one-to-one-open]'));
      else self.openMembership(self.root.querySelector('[data-membership-open]'));
    });
  };

  HbcBooking.prototype.waiverField = function (definition) {
    var wrapper = element('div', 'hbc-booking__field' + (definition.wide ? ' hbc-booking__field--wide' : ''));
    wrapper.dataset.waiverWrapper = definition.key;
    if (definition.key === 'postcode' && this.waiver.addressVerified) wrapper.hidden = true;
    var id = 'hbc-' + this.root.dataset.hbcBookingSection + '-waiver-' + definition.key;
    var label = element('label', '', definition.label);
    label.htmlFor = definition.segmented ? '' : id;
    if (definition.segmented) {
      var choices = element('div', 'hbc-booking__segmented');
      choices.setAttribute('role', 'radiogroup');
      choices.setAttribute('aria-label', definition.label);
      definition.options.forEach(function (option, optionIndex) {
        var choiceId = id + '-' + optionIndex;
        var radio = element('input');
        radio.type = 'radio';
        radio.id = choiceId;
        radio.name = id;
        radio.value = option.value;
        radio.required = definition.required !== false;
        radio.checked = String(this.waiver[definition.key] || '') === String(option.value);
        radio.dataset.waiverField = definition.key;
        if (this.waiverValidationErrors && this.waiverValidationErrors[definition.key]) {
          radio.setAttribute('aria-invalid', 'true');
        }
        var choiceLabel = element('label', 'hbc-booking__segment', option.label);
        choiceLabel.htmlFor = choiceId;
        choices.append(radio, choiceLabel);
      }, this);
      var segmentedError = element('p', 'hbc-booking__field-error');
      segmentedError.id = id + '-error';
      segmentedError.dataset.waiverErrorFor = definition.key;
      segmentedError.textContent = this.waiverValidationErrors && this.waiverValidationErrors[definition.key] || '';
      wrapper.append(label, choices, segmentedError);
      return wrapper;
    }
    var input = definition.options ? element('select') :
      (definition.multiline ? element('textarea') : element('input'));
    input.id = id;
    input.name = definition.key;
    if (!definition.multiline && !definition.options) input.type = definition.type || 'text';
    input.autocomplete = definition.autocomplete || 'off';
    input.required = definition.required !== false;
    if (definition.options) {
      var placeholder = element('option', '', definition.placeholder || 'Select an option');
      placeholder.value = '';
      input.appendChild(placeholder);
      definition.options.forEach(function (option) {
        var item = element('option', '', option.label);
        item.value = option.value;
        input.appendChild(item);
      });
    }
    input.value = this.waiver[definition.key] || '';
    if (definition.placeholder) input.placeholder = definition.placeholder;
    if (definition.min) input.min = definition.min;
    if (definition.max) input.max = definition.max;
    if (definition.maxlength) input.maxLength = definition.maxlength;
    if (definition.autocapitalize) input.setAttribute('autocapitalize', definition.autocapitalize);
    if (definition.spellcheck !== undefined) input.spellcheck = definition.spellcheck;
    input.dataset.waiverField = definition.key;
    if (this.waiverValidationErrors && this.waiverValidationErrors[definition.key]) {
      input.setAttribute('aria-invalid', 'true');
    }
    if (definition.addressLookup) {
      input.dataset.addressLookup = '';
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-expanded', 'false');
    }
    input.setAttribute('aria-describedby', id + '-error');
    if (definition.inputmode) input.inputMode = definition.inputmode;
    if (!definition.maxlength) {
      var defaultMaximum = definition.multiline ? 1000 :
        (input.type === 'email' ? 254 : (input.type === 'tel' ? 24 : 160));
      input.maxLength = defaultMaximum;
    }
    var error = element('p', 'hbc-booking__field-error');
    error.id = id + '-error';
    error.dataset.waiverErrorFor = definition.key;
    error.textContent = this.waiverValidationErrors && this.waiverValidationErrors[definition.key] || '';
    wrapper.append(label, input);
    if (definition.addressLookup) {
      var addressHelp = element('p', 'hbc-booking__field-help',
        'Choose an address from the suggestions. If it is not listed, type the complete address manually.');
      addressHelp.dataset.addressHelp = '';
      var results = element('div', 'hbc-booking__address-results');
      results.dataset.addressResults = '';
      results.setAttribute('role', 'listbox');
      results.hidden = true;
      wrapper.append(addressHelp, results);
    }
    wrapper.append(error);
    return wrapper;
  };

  HbcBooking.prototype.searchAddresses = function (term, input) {
    var self = this;
    var results = input.closest('.hbc-booking__field').querySelector('[data-address-results]');
    var query = normaliseText(term);
    var requestId = ++this.addressLookupRequest;
    if (!results) return;
    if (!this.cloudflareUrl || query.length < 5) {
      results.hidden = true;
      results.replaceChildren();
      input.setAttribute('aria-expanded', 'false');
      return;
    }
    results.hidden = false;
    results.replaceChildren(element('p', 'hbc-booking__address-status', 'Searching addresses…'));
    input.setAttribute('aria-expanded', 'true');
    if (this.addressLookupController) this.addressLookupController.abort();
    this.addressLookupController = typeof AbortController === 'function' ? new AbortController() : null;
    fetch(this.cloudflareUrl + '/v1/address/autocomplete', {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({ term: query, sessionToken: this.addressSessionToken }),
      credentials: 'omit',
      signal: this.addressLookupController ? this.addressLookupController.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('address-search-unavailable');
      return response.json();
    }).then(function (data) {
      if (requestId !== self.addressLookupRequest) return;
      results.replaceChildren();
      var suggestions = data && Array.isArray(data.suggestions) ? data.suggestions : [];
      if (!suggestions.length) {
        results.appendChild(element('p', 'hbc-booking__address-status',
          data && data.configured === false ?
            'Automatic address search is being configured. Enter the complete address manually.' :
            'No matching address found. Check the search or enter the complete address manually.'));
        return;
      }
      suggestions.forEach(function (suggestion) {
        var button = element('button', 'hbc-booking__address-suggestion', suggestion.address);
        button.type = 'button';
        button.dataset.addressSuggestion = suggestion.id;
        button.dataset.addressText = suggestion.address;
        results.appendChild(button);
      });
      if (data.provider === 'google') {
        results.appendChild(element('p', 'hbc-booking__address-attribution', 'Powered by Google'));
      }
    }).catch(function (error) {
      if (error && error.name === 'AbortError') return;
      if (requestId !== self.addressLookupRequest) return;
      results.replaceChildren(element('p', 'hbc-booking__address-status',
        'Address search is temporarily unavailable. Enter the complete address manually.'));
    });
  };

  HbcBooking.prototype.selectAddressSuggestion = function (button) {
    var self = this;
    if (!this.cloudflareUrl || this.submitting) return;
    button.disabled = true;
    button.textContent = 'Loading address…';
    fetch(this.cloudflareUrl + '/v1/address/resolve', {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({
        id: button.dataset.addressSuggestion,
        address: button.dataset.addressText,
        sessionToken: this.addressSessionToken
      }),
      credentials: 'omit'
    }).then(function (response) {
      if (!response.ok) throw new Error('address-resolve-unavailable');
      return response.json();
    }).then(function (data) {
      if (!data || data.ok !== true || !data.address || !data.postcode) {
        throw new Error('address-resolve-invalid');
      }
      self.waiver.address = data.address;
      self.waiver.postcode = data.postcode.toUpperCase();
      self.waiver.addressVerified = true;
      var addressInput = self.root.querySelector('[data-waiver-field="address"]');
      var postcodeInput = self.root.querySelector('[data-waiver-field="postcode"]');
      if (addressInput) {
        addressInput.value = self.waiver.address;
        addressInput.removeAttribute('aria-invalid');
        addressInput.setAttribute('aria-expanded', 'false');
        addressInput.classList.add('is-address-selected');
      }
      if (postcodeInput) {
        postcodeInput.value = self.waiver.postcode;
        postcodeInput.removeAttribute('aria-invalid');
      }
      var postcodeField = self.root.querySelector('[data-waiver-wrapper="postcode"]');
      if (postcodeField) postcodeField.hidden = true;
      var results = self.root.querySelector('[data-address-results]');
      if (results) {
        results.hidden = true;
        results.replaceChildren();
      }
      var help = self.root.querySelector('[data-address-help]');
      if (help) {
        help.textContent = 'Address selected — postcode completed automatically.';
        help.classList.add('is-selected');
      }
      ['address', 'postcode'].forEach(function (key) {
        var error = self.root.querySelector('[data-waiver-error-for="' + key + '"]');
        if (error) error.textContent = '';
      });
      self.announce('Address selected and postcode completed.');
      self.addressSessionToken = window.crypto && typeof window.crypto.randomUUID === 'function' ?
        window.crypto.randomUUID() : 'hbc-address-' + Date.now() + '-' + Math.random().toString(36).slice(2);
    }).catch(function () {
      button.disabled = false;
      button.textContent = 'Could not load this address. Try another result or enter it manually.';
    });
  };

  HbcBooking.prototype.waiverPhotoSection = function () {
    var section = element('fieldset', 'hbc-booking__waiver-section hbc-booking__photo-section');
    section.appendChild(element('legend', '', 'Identification photograph'));
    section.appendChild(element(
      'p',
      'hbc-booking__photo-notice',
      'A CLEAR, RECENT PHOTO OF THE PARTICIPANT IS REQUIRED TO COMPLETE THIS WAIVER. The photo helps authorised coaches match the participant\'s name to their face for safeguarding, accurate records and identification in an emergency. It is stored securely, is not published or used for marketing, and is not used for automated facial recognition. Access is restricted to authorised club personnel and the photo is handled in accordance with UK data protection law.'
    ));
    var photoPrivacy = element('p', 'hbc-booking__photo-help', 'For further information, read our ');
    var photoPrivacyLink = element('a', '', 'Privacy Policy');
    photoPrivacyLink.href = this.root.dataset.privacyUrl || '/policies/privacy-policy';
    photoPrivacyLink.target = '_blank';
    photoPrivacyLink.rel = 'noopener';
    photoPrivacy.appendChild(photoPrivacyLink);
    photoPrivacy.appendChild(document.createTextNode('.'));
    section.appendChild(photoPrivacy);
    var control = element('div', 'hbc-booking__photo-control');
    var id = 'hbc-' + this.root.dataset.hbcBookingSection + '-waiver-photo';
    var input = element('input', 'hbc-booking__photo-input');
    input.id = id;
    input.type = 'file';
    input.accept = 'image/*';
    input.dataset.waiverPhoto = '';
    input.setAttribute('aria-describedby', id + '-help ' + id + '-status ' + id + '-error');
    var label = element('label', 'hbc-booking__photo-button', this.waiver.photoPreview ? 'Replace photo' : 'Take or upload photo');
    label.htmlFor = id;
    var help = element('p', 'hbc-booking__photo-help', 'Use a well-lit, front-facing photo. JPG, PNG and supported phone photos up to 10 MB.');
    help.id = id + '-help';
    var status = element('p', 'hbc-booking__photo-status', this.photoPreparing ? 'Adding photo…' :
      (this.waiver.photoBase64 ? 'Photo ready ✓' : ''));
    status.id = id + '-status';
    status.dataset.waiverPhotoStatus = '';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    var preview = element('img', 'hbc-booking__photo-preview');
    preview.alt = 'Selected participant photograph';
    preview.dataset.waiverPhotoPreview = '';
    if (this.waiver.photoPreview) preview.src = this.waiver.photoPreview;
    else preview.hidden = true;
    var error = element('p', 'hbc-booking__field-error');
    error.id = id + '-error';
    error.dataset.waiverErrorFor = 'photoBase64';
    error.textContent = this.waiverValidationErrors && this.waiverValidationErrors.photoBase64 || '';
    if (error.textContent) input.setAttribute('aria-invalid', 'true');
    control.append(input, label, help, status, preview, error);
    section.appendChild(control);
    return section;
  };

  HbcBooking.prototype.handleWaiverPhoto = function (file, input) {
    var self = this;
    var error = this.root.querySelector('[data-waiver-error-for="photoBase64"]');
    var status = this.root.querySelector('[data-waiver-photo-status]');
    var preparationId = ++this.photoPreparationId;
    if (!file) return;
    if (!/^image\//.test(file.type) || file.size > 10 * 1024 * 1024) {
      input.value = '';
      if (error) error.textContent = 'Choose a JPG, PNG or phone photo no larger than 10 MB.';
      if (status) status.textContent = '';
      return;
    }
    this.photoPreparing = true;
    this.waiver.photoBase64 = '';
    this.waiver.photoMimeType = '';
    this.waiver.photoFileName = '';
    this.waiver.photoPreview = '';
    if (error) error.textContent = '';
    if (status) status.textContent = 'Adding photo…';
    this.updateWaiverSubmitState();
    this.compressWaiverPhoto(file).then(function (result) {
      if (preparationId !== self.photoPreparationId) return;
      self.photoPreparing = false;
      self.waiver.photoBase64 = result.base64;
      self.waiver.photoMimeType = 'image/jpeg';
      self.waiver.photoFileName = (file.name || 'participant-photo').replace(/\.[^.]+$/, '') + '.jpg';
      self.waiver.photoPreview = result.dataUrl;
      var preview = self.root.querySelector('[data-waiver-photo-preview]');
      if (preview) {
        preview.src = result.dataUrl;
        preview.hidden = false;
      }
      var label = self.root.querySelector('label[for="' + input.id + '"]');
      if (label) label.textContent = 'Replace photo';
      input.removeAttribute('aria-invalid');
      if (error) error.textContent = '';
      if (status) status.textContent = 'Photo ready ✓';
      if (self.waiverValidationErrors) delete self.waiverValidationErrors.photoBase64;
      self.updateWaiverValidationSummary();
      self.updateWaiverSubmitState();
    }).catch(function () {
      if (preparationId !== self.photoPreparationId) return;
      self.photoPreparing = false;
      input.value = '';
      if (status) status.textContent = '';
      if (error) error.textContent = 'Photo could not be added. Please choose a JPG, PNG or supported phone photo and try again.';
      self.updateWaiverSubmitState();
    });
  };

  HbcBooking.prototype.compressWaiverPhoto = function (file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onerror = reject;
      reader.onload = function () {
        var image = new Image();
        image.onerror = reject;
        image.onload = function () {
          var maximum = 480;
          var scale = Math.min(1, maximum / Math.max(image.naturalWidth, image.naturalHeight));
          var canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
          canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
          var context = canvas.getContext('2d');
          context.drawImage(image, 0, 0, canvas.width, canvas.height);
          var dataUrl = canvas.toDataURL('image/jpeg', 0.72);
          var base64 = dataUrl.split(',')[1] || '';
          if (!base64 || base64.length > 2000000) return reject(new Error('photo-too-large'));
          resolve({ dataUrl: dataUrl, base64: base64 });
        };
        image.src = reader.result;
      };
      reader.readAsDataURL(file);
    });
  };

  HbcBooking.prototype.waiverSection = function (title, definitions) {
    var section = element('fieldset', 'hbc-booking__waiver-section');
    section.appendChild(element('legend', '', title));
    var fields = element('div', 'hbc-booking__fields');
    definitions.forEach(function (definition) {
      fields.appendChild(this.waiverField(definition));
    }, this);
    section.appendChild(fields);
    return section;
  };

  HbcBooking.prototype.appendAcquisitionQuestion = function (step) {
    if (!this.waiver || this.waiver.attendedBefore !== 'no') return;
    var fields = [{
      key: 'acquisitionSource',
      label: 'How did you hear about Heathrow Boxing Club? (Required)',
      wide: true,
      placeholder: 'Choose an option',
      options: [
        { value: 'google-search', label: 'Google Search' },
        { value: 'google-maps', label: 'Google Maps' },
        { value: 'tiktok', label: 'TikTok' },
        { value: 'instagram', label: 'Instagram' },
        { value: 'facebook', label: 'Facebook' },
        { value: 'youtube', label: 'YouTube' },
        { value: 'recommendation', label: 'Friend or family recommendation' },
        { value: 'passed-club', label: 'Walked or drove past' },
        { value: 'local-organisation', label: 'School or local organisation' },
        { value: 'previous-member', label: 'Previous member' },
        { value: 'other', label: 'Other' }
      ]
    }];
    if (this.waiver.acquisitionSource === 'other') {
      fields.push({
        key: 'acquisitionSourceOther',
        label: 'Please tell us where you heard about us',
        wide: true,
        multiline: true,
        maxlength: 300
      });
    }
    step.appendChild(this.waiverSection('How you found us', fields));
  };

  HbcBooking.prototype.appendMedicalQuestion = function (step) {
    var fields = [{
      key: 'medicalDeclaration',
      label: 'Are there any medical conditions, injuries or health information the coaches should know about? (Required)',
      wide: true,
      segmented: true,
      options: [
        { value: 'no', label: 'No - nothing to declare' },
        { value: 'yes', label: 'Yes' }
      ]
    }];
    if (this.waiver.medicalDeclaration === 'yes') {
      fields.push({
        key: 'medicalConditionsOrInjuries',
        label: 'Please describe the condition, injury or health information, including asthma',
        required: true,
        wide: true,
        multiline: true,
        maxlength: 1500
      });
    }
    step.appendChild(this.waiverSection('Medical information', fields));
  };

  HbcBooking.prototype.waiverLegalPanel = function (title, paragraphs) {
    var panel = element('section', 'hbc-booking__waiver-legal');
    panel.appendChild(element('h4', '', title));
    paragraphs.forEach(function (paragraph) {
      panel.appendChild(element('p', '', paragraph));
    });
    return panel;
  };

  HbcBooking.prototype.waiverAgreement = function (signatureKey, signatureLabel, checkboxLabel) {
    var fragment = document.createDocumentFragment();
    fragment.appendChild(this.waiverSection('Signature', [
      { key: signatureKey, label: signatureLabel, autocomplete: 'off', autocapitalize: 'words', maxlength: 160, wide: true }
    ]));
    var agreement = element('div', 'hbc-booking__agreement');
    var id = 'hbc-' + this.root.dataset.hbcBookingSection + '-waiver-agreement';
    var checkbox = element('input');
    checkbox.type = 'checkbox';
    checkbox.id = id;
    checkbox.checked = Boolean(this.waiver.agreement);
    checkbox.dataset.waiverField = 'agreement';
    if (this.waiverValidationErrors && this.waiverValidationErrors.agreement) {
      checkbox.setAttribute('aria-invalid', 'true');
    }
    checkbox.setAttribute('aria-describedby', id + '-error');
    var label = element('label', '', checkboxLabel);
    label.htmlFor = id;
    var error = element('p', 'hbc-booking__field-error');
    error.id = id + '-error';
    error.dataset.waiverErrorFor = 'agreement';
    error.textContent = this.waiverValidationErrors && this.waiverValidationErrors.agreement || '';
    agreement.append(checkbox, label, error);
    fragment.appendChild(agreement);
    return fragment;
  };

  HbcBooking.prototype.marketingConsentCheckbox = function () {
    var agreement = element('div', 'hbc-booking__agreement hbc-booking__marketing-consent');
    var id = 'hbc-' + this.root.dataset.hbcBookingSection + '-marketing-consent';
    var checkbox = element('input');
    checkbox.type = 'checkbox';
    checkbox.id = id;
    checkbox.checked = Boolean(this.waiver.marketingConsent);
    checkbox.dataset.waiverField = 'marketingConsent';
    var label = element('label', '',
      'Yes, I would like occasional Heathrow Boxing Club news, offers and training reminders by email. I can unsubscribe at any time.');
    label.htmlFor = id;
    agreement.append(checkbox, label);
    return agreement;
  };

  HbcBooking.prototype.renderWaiverShell = function (title, intro) {
    var step = element('div', 'hbc-booking__step hbc-booking__waiver');
    var mobileBack = element('button', 'hbc-booking__mobile-back', '← Back');
    mobileBack.type = 'button';
    mobileBack.dataset.bookingAction = this.context === 'standalone' ? 'standalone-back' : 'back-booking-details';
    step.appendChild(mobileBack);
    step.appendChild(element('p', 'hbc-booking__selected-class', this.selectedClass.name));
    step.appendChild(element('h3', 'hbc-booking__step-heading', title));
    step.appendChild(element('p', 'hbc-booking__step-copy', intro));
    return step;
  };

  HbcBooking.prototype.renderAdultWaiverForm = function () {
    var step = this.renderWaiverShell('Adult waiver', 'Complete this once before choosing your class date and time.');
    step.appendChild(this.waiverSection('Personal details', [
      { key: 'firstName', label: 'First name', autocomplete: 'section-hbc-adult given-name', autocapitalize: 'words' },
      { key: 'lastName', label: 'Last name', autocomplete: 'section-hbc-adult family-name', autocapitalize: 'words' },
      { key: 'phone', label: 'UK mobile number (+44, omit the first 0)', type: 'tel', autocomplete: 'section-hbc-adult tel', inputmode: 'tel', placeholder: '+44 7XXXXXXXXX' },
      { key: 'email', label: 'Email address', type: 'email', autocomplete: 'section-hbc-adult email', autocapitalize: 'none', spellcheck: false },
      { key: 'address', label: 'Find your home address', autocomplete: 'section-hbc-adult street-address', autocapitalize: 'words', maxlength: 300, wide: true, addressLookup: true, placeholder: 'Start typing your house number and street or postcode' },
      { key: 'postcode', label: 'Postcode', autocomplete: 'section-hbc-adult postal-code', autocapitalize: 'characters', maxlength: 9 },
      {
        key: 'attendedBefore',
        label: 'Have you ever attended a class at Heathrow Boxing Club before? (Required)',
        wide: true,
        segmented: true,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ]
      }
    ]));
    this.appendAcquisitionQuestion(step);
    step.appendChild(this.waiverSection('Participant details', [
      { key: 'dateOfBirth', label: 'Date of birth (must be aged 18 or older)', type: 'date',
        autocomplete: 'bday', wide: true, max: adultLatestEligibleBirthDate() }
    ]));
    this.appendMedicalQuestion(step);
    step.appendChild(this.waiverSection('Emergency contact', [
      { key: 'emergencyContactName', label: 'Emergency contact name', autocomplete: 'section-hbc-emergency name', autocapitalize: 'words' },
      { key: 'emergencyContactRelationship', label: 'Relationship to you', autocomplete: 'off', options: [
        { value: 'parent', label: 'Parent' }, { value: 'guardian', label: 'Guardian' },
        { value: 'spouse', label: 'Spouse' }, { value: 'partner', label: 'Partner' },
        { value: 'sibling', label: 'Sibling' }, { value: 'relative', label: 'Other relative' },
        { value: 'friend', label: 'Friend' }, { value: 'carer', label: 'Carer' },
        { value: 'other', label: 'Other' }
      ] },
      { key: 'emergencyContactNumber', label: 'Emergency contact number', type: 'tel', autocomplete: 'section-hbc-emergency tel', inputmode: 'tel', wide: true }
    ]));
    step.appendChild(this.waiverPhotoSection());
    step.appendChild(this.waiverLegalPanel('WAIVER & RELEASE OF LIABILITY FORM', ADULT_WAIVER_PARAGRAPHS));
    step.appendChild(this.waiverAgreement(
      'signedName',
      'Type your full name to sign',
      'I confirm that I have read and agree to the waiver and release of liability above.'
    ));
    step.appendChild(this.marketingConsentCheckbox());
    this.appendWaiverActions(step);
    return step;
  };

  HbcBooking.prototype.renderJuniorWaiverForm = function () {
    var step = this.renderWaiverShell('Junior waiver',
      'For participants aged 11 to 17. A parent or legal guardian must complete and sign this form.');
    step.appendChild(element('p', 'hbc-booking__submission-notice',
      'Registering brothers or sisters? You may use the same parent email address and phone number for each child. Enter the child’s own first name, last name and date of birth so each child receives a separate waiver and QR code.'));
    step.appendChild(this.waiverSection('Junior and parent / guardian details', [
      { key: 'juniorFirstName', label: 'Junior first name', autocomplete: 'section-hbc-junior given-name', autocapitalize: 'words' },
      { key: 'juniorLastName', label: 'Junior last name', autocomplete: 'section-hbc-junior family-name', autocapitalize: 'words' },
      { key: 'mobileContactNumber', label: 'Parent / guardian UK mobile (+44, omit the first 0)', type: 'tel', autocomplete: 'section-hbc-guardian tel', inputmode: 'tel', placeholder: '+44 7XXXXXXXXX' },
      { key: 'email', label: 'Parent / guardian email address', type: 'email', autocomplete: 'section-hbc-guardian email', autocapitalize: 'none', spellcheck: false },
      { key: 'address', label: 'Find the junior’s home address', autocomplete: 'section-hbc-junior street-address', autocapitalize: 'words', maxlength: 300, wide: true, addressLookup: true, placeholder: 'Start typing the house number and street or postcode' },
      { key: 'postcode', label: 'Postcode', autocomplete: 'section-hbc-junior postal-code', autocapitalize: 'characters', maxlength: 9 },
      {
        key: 'attendedBefore',
        label: 'Has the junior participant ever attended a class at Heathrow Boxing Club before? (Required)',
        wide: true,
        segmented: true,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ]
      }
    ]));
    this.appendAcquisitionQuestion(step);
    step.appendChild(this.waiverSection('Junior details', [
      { key: 'juniorDateOfBirth', label: 'Junior date of birth (must be aged 11 or older)',
        type: 'date', autocomplete: 'bday', min: juniorEarliestEligibleBirthDate(),
        max: juniorLatestEligibleBirthDate() },
      {
        key: 'juniorPronouns', label: 'Pronouns used in this agreement',
        options: [
          { value: 'he', label: 'He / him / his' },
          { value: 'she', label: 'She / her / hers' },
          { value: 'they', label: 'They / them / theirs' }
        ]
      }
    ]));
    this.appendMedicalQuestion(step);
    step.appendChild(this.waiverSection('Emergency contact (parent/legal guardian)', [
      { key: 'emergencyContactName', label: 'Emergency contact name', autocomplete: 'section-hbc-emergency name', autocapitalize: 'words' },
      { key: 'emergencyContactRelationship', label: 'Relationship to junior', autocomplete: 'off', options: [
        { value: 'parent', label: 'Parent' }, { value: 'guardian', label: 'Guardian' },
        { value: 'sibling', label: 'Sibling' }, { value: 'relative', label: 'Other relative' },
        { value: 'friend', label: 'Family friend' }, { value: 'carer', label: 'Carer' },
        { value: 'other', label: 'Other' }
      ] },
      { key: 'emergencyContactNumber', label: 'Emergency contact number', type: 'tel', autocomplete: 'section-hbc-emergency tel', inputmode: 'tel', wide: true }
    ]));
    step.appendChild(this.waiverSection('Photography and video consent', [{
      key: 'promotionalPhotoConsent',
      label: 'May the junior be photographed or filmed for coaching or promotional activities?',
      wide: true,
      options: [
        { value: 'accepted', label: 'I accept' },
        { value: 'not-accepted', label: 'I do not accept' }
      ]
    }]));
    step.appendChild(this.waiverPhotoSection());
    step.appendChild(this.juniorWaiverLegalPanel());
    step.appendChild(this.waiverAgreement(
      'signedByParentOrGuardian',
      'Type parent or legal guardian full name to sign',
      'I confirm that I am the parent or legal guardian, and that I have read and agree to the waiver and parental consent above on the junior’s behalf.'
    ));
    step.appendChild(this.marketingConsentCheckbox());
    this.appendWaiverActions(step);
    return step;
  };

  HbcBooking.prototype.juniorAgreementCopy = function () {
    var name = normaliseText(this.waiver.juniorFirstName + ' ' + this.waiver.juniorLastName) || '[junior name]';
    var pronouns = {
      he: { subject: 'he', object: 'him', possessive: 'his', verb: 'is' },
      she: { subject: 'she', object: 'her', possessive: 'her', verb: 'is' },
      they: { subject: 'they', object: 'them', possessive: 'their', verb: 'are' }
    }[this.waiver.juniorPronouns] ||
      { subject: '[they]', object: '[them]', possessive: '[their]', verb: '[are]' };
    var photoChoice = this.waiver.promotionalPhotoConsent === 'accepted' ? 'accept' :
      (this.waiver.promotionalPhotoConsent === 'not-accepted' ? 'do not accept' : '[accept or do not accept]');
    return [
      'Please ensure parent/legal guardian completes and signs this form.',
      'As part of the registration process, the junior member will have a facial photograph taken which will be kept on file for security purposes only. This photograph will not be shared with any third parties. By signing this form you are agreeing to this.',
      'Heathrow Boxing Club complies with the ENGLAND BOXING Child Protection Policies including changing rooms, anti-bullying and photography/video procedures.',
      'A copy can be viewed at www.englandboxing.org',
      'I ' + photoChoice + ' that ' + pronouns.subject + ' can be photographed or filmed for coaching or promotional activities.',
      'All reasonable steps will be taken to contact yourself on the details provided in the event of an injury or illness.',
      'I, the parent/legal guardian of ' + name + ', agree that ' + pronouns.subject + ' can take part in the club activities and that:',
      'I ASSUME ALL THE RISKS OF ' + pronouns.object.toUpperCase() + ' PARTICIPATING IN BOXING, FITNESS, CONTACT SPARRING OR ANY OTHER FORM OF PHYSICAL ACTIVITY offered by Heathrow Boxing Club. This is done of ' + pronouns.possessive.toUpperCase() + ' own free will and the coaches/staff/volunteers of Heathrow Boxing Club will not be liable for any injury or consequences that may arise from negligence or carelessness from the coaches/staff/volunteers instructing such activities including from dangerous or defective equipment or property owned, maintained, or controlled by them.',
      'I CERTIFY that ' + pronouns.subject.toUpperCase() + ' ' + pronouns.verb + ' physically fit to participate in the activities or events offered by Heathrow Boxing Club, and has not been advised to not participate by a qualified medical professional. I certify that there are no health-related reasons or problems which preclude ' + pronouns.possessive + ' participation in these programmes, activities, or events onsite or offsite the Heathrow Boxing Club premises.',
      'I ACKNOWLEDGE that I am fully required to provide my own medical coverage and that Heathrow Boxing Club will not be held liable for any expenses incurred for treatment of injuries while participating in these programmes, activities, or events.',
      'I, THE PARENT/LEGAL GUARDIAN OF ' + name.toUpperCase() + ', AM AWARE THAT THIS IS A RELEASE OF LIABILITY FORM AND I AGREE TO THIS ON ' + pronouns.possessive.toUpperCase() + ' BEHALF.'
    ];
  };

  HbcBooking.prototype.juniorWaiverLegalPanel = function () {
    var panel = this.waiverLegalPanel(
      'WAIVER & RELEASE OF LIABILITY FORM AND PARENTAL CONSENT',
      this.juniorAgreementCopy()
    );
    Array.prototype.forEach.call(panel.querySelectorAll('p'), function (paragraph, index) {
      paragraph.dataset.juniorLegal = String(index);
    });
    return panel;
  };

  HbcBooking.prototype.updateJuniorAgreementText = function () {
    if (!this.waiver) return;
    var copy = this.juniorAgreementCopy();
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-junior-legal]'), function (paragraph) {
      paragraph.textContent = copy[Number(paragraph.dataset.juniorLegal)] || '';
    });
  };

  HbcBooking.prototype.appendWaiverActions = function (step) {
    if (this.waiverError) {
      var errorBox = element('div', 'hbc-booking__submission-error', this.waiverError);
      errorBox.setAttribute('role', 'alert');
      step.appendChild(errorBox);
    }
    var privacy = element(
      'p',
      'hbc-booking__privacy',
      'Your information and identification photograph are stored securely for club administration and safety. '
    );
    var privacyLink = element('a', '', 'Read our Privacy Policy');
    privacyLink.href = this.root.dataset.privacyUrl || '/policies/privacy-policy';
    privacyLink.target = '_blank';
    privacyLink.rel = 'noopener';
    privacy.appendChild(privacyLink);
    step.appendChild(privacy);
    var validationSummary = element('section', 'hbc-booking__validation-summary');
    validationSummary.dataset.waiverValidationSummary = '';
    validationSummary.setAttribute('role', 'alert');
    validationSummary.setAttribute('aria-live', 'assertive');
    validationSummary.setAttribute('tabindex', '-1');
    validationSummary.hidden = true;
    step.appendChild(validationSummary);
    var actions = element('div', 'hbc-booking__actions');
    var back = element('button', 'hbc-booking__button hbc-booking__button--text', 'Back');
    back.type = 'button';
    back.dataset.bookingAction = this.context === 'standalone' ? 'standalone-back' : 'back-booking-details';
    back.disabled = this.submitting;
    var submit = element('button', 'hbc-booking__button', this.submitting ? 'Saving waiver…' : 'Complete waiver');
    submit.type = 'button';
    submit.dataset.bookingAction = 'submit-waiver';
    submit.disabled = this.submitting || this.photoPreparing;
    actions.append(back, submit);
    step.appendChild(actions);
    this.updateWaiverValidationSummary(validationSummary);
  };

  HbcBooking.prototype.renderClassStep = function () {
    var self = this;
    var step = element('div', 'hbc-booking__step');
    step.appendChild(element('h3', 'hbc-booking__step-heading', 'Choose a class'));
    step.appendChild(element('p', 'hbc-booking__step-copy', 'Select the class you would like to attend.'));
    var grid = element('div', 'hbc-booking__flow-classes');
    sortGroups(this.groups, true).forEach(function (group) {
      var button = element('button', 'hbc-booking__choice');
      button.type = 'button';
      button.dataset.classKey = group.key;
      button.appendChild(element('strong', '', group.name));
      button.appendChild(element('span', '', timetableLabel(group)));
      grid.appendChild(button);
    });
    step.appendChild(grid);
    if (self.mode === 'compact') {
      var actions = element('div', 'hbc-booking__actions');
      var close = element('button', 'hbc-booking__button hbc-booking__button--secondary', 'Close');
      close.type = 'button';
      close.dataset.bookingClose = '';
      actions.appendChild(close);
      step.appendChild(actions);
    }
    return step;
  };

  HbcBooking.prototype.renderSessionStep = function () {
    var self = this;
    var step = element('div', 'hbc-booking__step');
    var back = element('button', 'hbc-booking__button hbc-booking__button--text', 'Back to classes');
    back.type = 'button';
    back.dataset.bookingAction = 'back-classes';
    step.appendChild(back);
    step.appendChild(element('h3', 'hbc-booking__step-heading', 'Choose a session'));
    step.appendChild(element(
      'p',
      'hbc-booking__step-copy',
      this.selectedClass.name + ' · Select a time to continue automatically'
    ));
    if (!this.sessions.length) {
      step.appendChild(element('p', '', 'There are no upcoming sessions available for this class right now.'));
    } else {
      var grid = element('div', 'hbc-booking__session-grid');
      this.sessions.forEach(function (session) {
        var key = session.date + 'T' + session.time;
        var button = element('button', 'hbc-booking__choice');
        button.type = 'button';
        button.dataset.sessionKey = key;
        button.setAttribute('aria-pressed', String(Boolean(self.selectedSession && self.selectedSession.date === session.date && self.selectedSession.time === session.time)));
        button.appendChild(element('strong', '', shortDate(session)));
        button.appendChild(element('span', '', session.time));
        grid.appendChild(button);
      });
      step.appendChild(grid);
    }
    return step;
  };

  HbcBooking.prototype.summary = function () {
    var summary = element('aside', 'hbc-booking__summary');
    summary.appendChild(element('h3', '', 'Your booking'));
    summary.appendChild(element('p', '', this.selectedClass.name));
    summary.appendChild(element('p', '', longDate(this.selectedSession) + ' at ' + this.selectedSession.time));
    var member = this.customerProfile && this.customerProfile.member &&
      this.customerProfile.member.active;
    summary.appendChild(element(
      'p',
      'hbc-booking__summary-price',
      member ? 'Included with membership' : formatPrice(this.selectedClass.price).replace(' per class', '')
    )).dataset.bookingSummaryPrice = '';
    var payment = element('p', '', member ? 'No class payment due' : 'Pay on arrival');
    payment.dataset.bookingSummaryPayment = '';
    summary.appendChild(payment);
    return summary;
  };

  HbcBooking.prototype.customerSignature = function () {
    var details = this.details;
    if (!details.firstName.trim() || !details.lastName.trim() ||
      !validUkMobile(details.phone)) return '';
    return [
      details.firstName, details.lastName, details.phone,
      isJuniorGroup(this.selectedClass) ? 'junior' : 'adult'
    ].map(normaliseText).join('|').toLowerCase();
  };

  HbcBooking.prototype.updateMemberDisplay = function () {
    var junior = isJuniorGroup(this.selectedClass);
    var member = this.customerProfile && this.customerProfile.member &&
      this.customerProfile.member.active ? this.customerProfile.member : null;
    var welcome = this.root.querySelector('[data-member-welcome]');
    var price = this.root.querySelector('[data-booking-summary-price]');
    var payment = this.root.querySelector('[data-booking-summary-payment]');
    if (welcome) {
      welcome.hidden = junior || !member;
      welcome.textContent = member ?
        'Welcome back, ' + (member.firstName || this.details.firstName) +
          '. Your membership covers this class. Good work keeping your training consistent.' :
        '';
    }
    if (price) {
      price.textContent = !junior && this.lookupState === 'checking' ?
        'Checking membership...' :
        (member ?
          '£0 - Included with membership' :
          formatPrice(this.selectedClass.price).replace(' per class', ''));
      price.classList.toggle('is-member', Boolean(member));
    }
    if (payment) {
      payment.textContent = !junior && this.lookupState === 'checking' ?
        'Please wait before confirming' :
        (this.lookupState === 'unavailable' ?
          'Membership check unavailable - please try again' :
          (member ? 'Nothing to pay on arrival' : 'Pay on arrival'));
    }
  };

  HbcBooking.prototype.lookupCustomer = function () {
    var self = this;
    var junior = isJuniorGroup(this.selectedClass);
    var details = this.details;
    var signature = this.customerSignature();
    if (!signature) return Promise.resolve(null);
    if (signature === this.lookupSignature) {
      return this.lookupPromise || Promise.resolve(this.customerProfile);
    }
    var cached = MEMBER_LOOKUP_CACHE.get(signature);
    if (cached && Date.now() - cached.savedAt < 5 * 60 * 1000) {
      this.customerProfile = cached.data;
      this.waiverId = cached.data.waiverFound ? normaliseText(cached.data.waiverId) : '';
      this.lookupSignature = signature;
      this.lookupCompleteSignature = signature;
      this.lookupPending = false;
      this.lookupState = cached.data.member && cached.data.member.active ? 'member' : 'not-member';
      this.updateMemberDisplay();
      return Promise.resolve(cached.data);
    }
    this.lookupSignature = signature;
    this.lookupPending = true;
    this.lookupState = 'checking';
    this.updateMemberDisplay();
    var lookupPayload = {
      firstName: details.firstName,
      lastName: details.lastName,
      phone: details.phone,
      email: validEmail(details.email) ? details.email : '',
      skipMember: junior,
      className: this.selectedClass && this.selectedClass.name || ''
    };
    var appsScriptLookup = function () { return fetch(self.apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({
        type: 'customer-lookup',
        firstName: lookupPayload.firstName,
        lastName: lookupPayload.lastName,
        phone: lookupPayload.phone,
        email: lookupPayload.email,
        skipMember: lookupPayload.skipMember,
        className: lookupPayload.className
      }),
      redirect: 'follow',
      credentials: 'omit'
    }); };
    var readLookupResponse = function (response) {
      if (!response.ok) throw new Error('lookup-failed');
      return response.json();
    };
    var authoritativeLookup = function () {
      return appsScriptLookup().then(readLookupResponse);
    };
    var lookupRequest = this.cloudflareUrl ?
      fetch(this.cloudflareUrl + '/v1/booking/customer-lookup', {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(lookupPayload),
        credentials: 'omit'
      }).then(function (response) {
        if (!response.ok) throw new Error('cloudflare-lookup-failed');
        return response.json();
      }).then(function (data) {
        // D1 is a fast mirror, not the waiver authority. Confirm a negative
        // result against Sheets before asking an existing customer to sign again.
        return data && data.ok === true && data.waiverFound === false && data.authoritative !== true ?
          authoritativeLookup() : data;
      }).catch(authoritativeLookup) : authoritativeLookup();
    this.lookupPromise = lookupRequest.then(function (data) {
      if (!data || data.ok !== true) {
        self.lookupSignature = '';
        self.lookupState = 'unavailable';
        self.updateMemberDisplay();
        return null;
      }
      if (signature !== self.customerSignature()) return null;
      self.customerProfile = data;
      self.waiverId = data.waiverFound ? normaliseText(data.waiverId) : '';
      MEMBER_LOOKUP_CACHE.set(signature, { data: data, savedAt: Date.now() });
      self.lookupCompleteSignature = signature;
      self.lookupState = data.member && data.member.active ? 'member' : 'not-member';
      self.updateMemberDisplay();
      return data;
    }).catch(function () {
      self.lookupSignature = '';
      self.lookupState = 'unavailable';
      self.updateMemberDisplay();
      return null;
    }).finally(function () {
      if (signature === self.customerSignature()) self.lookupPending = false;
      self.lookupPromise = null;
    });
    return this.lookupPromise;
  };

  HbcBooking.prototype.fastCustomerLookup = function (payload) {
    var self = this;
    payload = Object.assign({}, payload, {
      className: payload.className || (this.selectedClass && this.selectedClass.name) || ''
    });
    var appsScriptLookup = function () {
      return fetch(self.apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(Object.assign({ type: 'customer-lookup' }, payload)),
        redirect: 'follow',
        credentials: 'omit'
      }).then(function (response) {
        if (!response.ok) throw new Error('lookup-failed');
        return response.json();
      });
    };
    if (!this.cloudflareUrl) return appsScriptLookup();
    return fetch(this.cloudflareUrl + '/v1/booking/customer-lookup', {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
      credentials: 'omit'
    }).then(function (response) {
      if (!response.ok) throw new Error('cloudflare-lookup-failed');
      return response.json();
    }).catch(appsScriptLookup);
  };

  HbcBooking.prototype.renderDetailsStep = function () {
    var step = element('div', 'hbc-booking__step');
    step.appendChild(element('h3', 'hbc-booking__step-heading', 'Enter your details'));
    step.appendChild(element('p', 'hbc-booking__step-copy', 'Check your session, then confirm your booking.'));
    var layout = element('div', 'hbc-booking__form-layout');
    var formArea = element('div');
    var memberWelcome = element('div', 'hbc-booking__member-welcome');
    memberWelcome.dataset.memberWelcome = '';
    memberWelcome.hidden = true;
    formArea.appendChild(memberWelcome);
    var fields = element('div', 'hbc-booking__fields');
    [
      { key: 'firstName', label: 'First name', type: 'text', autocomplete: 'given-name' },
      { key: 'lastName', label: 'Last name', type: 'text', autocomplete: 'family-name' },
      { key: 'phone', label: 'UK mobile number (+44, omit the first 0)', type: 'tel', autocomplete: 'tel', placeholder: '+44 7XXXXXXXXX' },
      { key: 'email', label: 'Email address', type: 'email', autocomplete: 'email' }
    ].forEach(function (definition) {
      var wrapper = element('div', 'hbc-booking__field');
      var id = 'hbc-' + this.root.dataset.hbcBookingSection + '-' + definition.key;
      var label = element('label', '', definition.label);
      label.htmlFor = id;
      var input = element('input');
      input.id = id;
      input.name = definition.key;
      input.type = definition.type;
      input.autocomplete = definition.autocomplete;
      input.required = true;
      input.value = this.details[definition.key];
      if (definition.placeholder) input.placeholder = definition.placeholder;
      input.dataset.bookingField = definition.key;
      input.setAttribute('aria-describedby', id + '-error');
      var error = element('p', 'hbc-booking__field-error');
      error.id = id + '-error';
      error.dataset.errorFor = definition.key;
      wrapper.append(label, input, error);
      fields.appendChild(wrapper);
    }, this);
    formArea.appendChild(fields);
    if (this.submissionError) {
      var errorBox = element('div', 'hbc-booking__submission-error', this.submissionError);
      errorBox.setAttribute('role', 'alert');
      formArea.appendChild(errorBox);
    }
    layout.append(formArea, this.summary());
    step.appendChild(layout);
    var actions = element('div', 'hbc-booking__actions');
    var back = element('button', 'hbc-booking__button hbc-booking__button--text', 'Back to sessions');
    back.type = 'button';
    back.dataset.bookingAction = 'back-sessions';
    back.disabled = this.submitting;
    var submit = element('button', 'hbc-booking__button', this.submitting ? 'Confirming…' : 'Confirm Booking');
    submit.type = 'button';
    submit.dataset.bookingAction = 'submit';
    submit.disabled = this.submitting;
    actions.append(back, submit);
    step.appendChild(actions);
    window.setTimeout(this.updateMemberDisplay.bind(this), 0);
    return step;
  };

  HbcBooking.prototype.validateDetails = function () {
    var values = {};
    Object.keys(this.details).forEach(function (key) {
      values[key] = this.details[key].trim();
    }, this);
    var errors = {};
    if (!values.firstName) errors.firstName = 'Enter your first name.';
    if (!values.lastName) errors.lastName = 'Enter your last name.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) errors.email = 'Enter a valid email address.';
    var compactPhone = values.phone.replace(/[\s()-]/g, '');
    if (!/^(?:07\d{9}|\+447\d{9}|00447\d{9})$/.test(compactPhone)) {
      errors.phone = 'Enter a valid UK mobile number.';
    }
    this.details = values;
    return errors;
  };

  HbcBooking.prototype.showValidation = function (errors) {
    var firstInvalid = null;
    Object.keys(errors).forEach(function (key) {
      var input = this.root.querySelector('[data-booking-field="' + key + '"]');
      var message = this.root.querySelector('[data-error-for="' + key + '"]');
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        if (!firstInvalid) firstInvalid = input;
      }
      if (message) message.textContent = errors[key];
    }, this);
    this.announce('Please correct the highlighted fields.');
    if (firstInvalid) firstInvalid.focus();
  };

  HbcBooking.prototype.validateWaiver = function () {
    var values = {};
    Object.keys(this.waiver || {}).forEach(function (key) {
      values[key] = typeof this.waiver[key] === 'string' ? this.waiver[key].trim() : this.waiver[key];
    }, this);
    if (typeof values.postcode === 'string') values.postcode = values.postcode.toUpperCase();
    if (values.medicalDeclaration === 'no') values.medicalConditionsOrInjuries = 'None';
    var errors = {};
    var required = isJuniorGroup(this.selectedClass) ?
      ['juniorFirstName', 'juniorLastName', 'juniorDateOfBirth', 'juniorPronouns', 'attendedBefore', 'mobileContactNumber', 'email', 'address', 'postcode', 'emergencyContactName', 'emergencyContactRelationship', 'emergencyContactNumber', 'promotionalPhotoConsent', 'photoBase64', 'signedByParentOrGuardian'] :
      ['firstName', 'lastName', 'phone', 'address', 'dateOfBirth', 'email', 'attendedBefore', 'postcode', 'emergencyContactName', 'emergencyContactRelationship', 'emergencyContactNumber', 'photoBase64', 'signedName'];
    required.forEach(function (key) {
      if (!values[key]) errors[key] = 'This field is required.';
    });
    if (!values.medicalDeclaration) errors.medicalDeclaration = 'Choose Yes or No.';
    if (values.medicalDeclaration === 'yes' && !values.medicalConditionsOrInjuries) {
      errors.medicalConditionsOrInjuries = 'Please describe the medical or health information.';
    }
    if (values.attendedBefore === 'no') {
      if (!values.acquisitionSource) errors.acquisitionSource = 'Choose how you heard about Heathrow Boxing Club.';
      if (values.acquisitionSource === 'other' && !values.acquisitionSourceOther) {
        errors.acquisitionSourceOther = 'Please tell us where you heard about us.';
      }
    }
    if (values.email && !validEmail(values.email)) errors.email = 'Enter a valid email address.';
    var mobileKey = isJuniorGroup(this.selectedClass) ? 'mobileContactNumber' : 'phone';
    if (values[mobileKey] && !validUkMobile(values[mobileKey])) errors[mobileKey] = 'Enter a valid UK mobile number.';
    if (values.emergencyContactNumber && !validUkPhone(values.emergencyContactNumber)) {
      errors.emergencyContactNumber = 'Enter a valid UK contact number.';
    }
    if (values.postcode && !validUkPostcode(values.postcode)) errors.postcode = 'Enter a valid UK postcode.';
    var nameKeys = isJuniorGroup(this.selectedClass) ?
      ['juniorFirstName', 'juniorLastName'] : ['firstName', 'lastName'];
    nameKeys.forEach(function (key) {
      if (values[key] && !meaningfulPersonName(values[key], false)) {
        errors[key] = 'Enter a real name using letters, spaces, apostrophes or hyphens.';
      }
    });
    if (values.emergencyContactName && !meaningfulPersonName(values.emergencyContactName, true)) {
      errors.emergencyContactName = 'Enter the emergency contact’s full name.';
    }
    if (values.emergencyContactRelationship && !validRelationship(values.emergencyContactRelationship)) {
      errors.emergencyContactRelationship = 'Choose their relationship from the list.';
    }
    if (values.address && !meaningfulAddress(values.address)) {
      errors.address = 'Search for and select a complete home address, or enter the full address manually.';
    }
    var dobKey = isJuniorGroup(this.selectedClass) ? 'juniorDateOfBirth' : 'dateOfBirth';
    var today = new Date();
    var todayString = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
    if (values[dobKey] && values[dobKey] > todayString) errors[dobKey] = 'Date of birth cannot be in the future.';
    if (isJuniorGroup(this.selectedClass) && values.juniorDateOfBirth &&
      ageOnDate(values.juniorDateOfBirth, todayString) < 11) {
      errors.juniorDateOfBirth = 'Junior participants must be aged 11 or older.';
    }
    if (isJuniorGroup(this.selectedClass) && values.juniorDateOfBirth &&
      ageOnDate(values.juniorDateOfBirth, todayString) >= 18) {
      errors.juniorDateOfBirth = 'Junior classes are for participants aged 11 to 17. Please choose an adult class.';
    }
    if (!isJuniorGroup(this.selectedClass) && values.dateOfBirth) {
      if (ageOnDate(values.dateOfBirth, todayString) < 18) {
        errors.dateOfBirth = 'Adult classes require an adult waiver. Please choose an appropriate junior class or contact Heathrow Boxing Club.';
      }
      if (normalisedName(values.signedName) !== normalisedName(values.firstName + ' ' + values.lastName)) {
        errors.signedName = 'Your signature must match your first and last name.';
      }
    }
    if (!values.agreement) errors.agreement = 'You must confirm the agreement before continuing.';
    this.waiver = values;
    return errors;
  };

  HbcBooking.prototype.isWaiverReady = function () {
    if (!this.waiver) return false;
    return Object.keys(this.validateWaiver()).length === 0;
  };

  HbcBooking.prototype.updateWaiverSubmitState = function () {
    var button = this.root.querySelector('[data-booking-action="submit-waiver"]');
    if (button) {
      button.disabled = this.submitting || this.photoPreparing;
      if (this.photoPreparing) button.textContent = 'Preparing photo…';
      else if (!this.submitting) button.textContent = 'Complete waiver';
    }
    if (this.waiver && !isJuniorGroup(this.selectedClass) && this.waiver.signedName) {
      var signatureError = this.root.querySelector('[data-waiver-error-for="signedName"]');
      if (signatureError && normalisedName(this.waiver.signedName) !== normalisedName(this.waiver.firstName + ' ' + this.waiver.lastName)) {
        signatureError.textContent = 'Your signature must match your first and last name.';
      }
    }
  };

  HbcBooking.prototype.waiverIssueTarget = function (key) {
    return this.root.querySelector('[data-waiver-wrapper="' + key + '"]') ||
      (key === 'photoBase64' ? this.root.querySelector('.hbc-booking__photo-section') : null) ||
      this.root.querySelector('[data-waiver-field="' + key + '"]');
  };

  HbcBooking.prototype.focusFirstWaiverIssue = function () {
    var key = Object.keys(this.waiverValidationErrors || {})[0];
    if (!key) return;
    var target = this.waiverIssueTarget(key);
    var input = this.root.querySelector('[data-waiver-field="' + key + '"]') ||
      (key === 'photoBase64' ? this.root.querySelector('[data-waiver-photo]') : null);
    if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (input && input.focus) {
      window.setTimeout(function () {
        try { input.focus({ preventScroll: true }); } catch (error) { input.focus(); }
      }, 250);
    }
  };

  HbcBooking.prototype.updateWaiverValidationSummary = function (existingSummary) {
    var summary = existingSummary || this.root.querySelector('[data-waiver-validation-summary]');
    if (!summary) return;
    var errors = this.waiverValidationErrors || {};
    var keys = Object.keys(errors);
    summary.replaceChildren();
    summary.hidden = keys.length === 0;
    if (!keys.length) return;
    var heading = element('h4', '', 'We need ' + keys.length + ' more ' + (keys.length === 1 ? 'detail' : 'details'));
    var intro = element('p', '', 'Please correct the following before completing your waiver:');
    var list = element('ul');
    keys.forEach(function (key) { list.appendChild(element('li', '', errors[key])); });
    var fix = element('button', 'hbc-booking__button hbc-booking__button--secondary', 'Fix first issue');
    fix.type = 'button';
    fix.dataset.bookingAction = 'waiver-fix-first';
    summary.append(heading, intro, list, fix);
  };

  HbcBooking.prototype.showWaiverValidation = function (errors) {
    this.waiverValidationErrors = errors;
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-waiver-field], [data-waiver-photo]'), function (input) {
      input.removeAttribute('aria-invalid');
    });
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-waiver-error-for]'), function (message) {
      message.textContent = '';
    });
    Object.keys(errors).forEach(function (key) {
      var input = this.root.querySelector('[data-waiver-field="' + key + '"]') ||
        (key === 'photoBase64' ? this.root.querySelector('[data-waiver-photo]') : null);
      var message = this.root.querySelector('[data-waiver-error-for="' + key + '"]');
      if (input) {
        input.setAttribute('aria-invalid', 'true');
      }
      if (message) message.textContent = errors[key];
    }, this);
    this.updateWaiverValidationSummary();
    this.announce('Please correct the highlighted waiver fields.');
    var summary = this.root.querySelector('[data-waiver-validation-summary]');
    if (summary) {
      summary.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      try { summary.focus({ preventScroll: true }); } catch (error) { summary.focus(); }
    }
  };

  HbcBooking.prototype.submitWaiver = function () {
    var self = this;
    if (this.submitting || this.photoPreparing || !this.waiver || this.waiverId) return;
    var errors = this.validateWaiver();
    if (Object.keys(errors).length) return this.showWaiverValidation(errors);
    trackBookingEvent(this, 'waiver_started');
    this.submitting = true;
    if (!this.waiverAttemptId) {
      this.waiverAttemptId = window.crypto && typeof window.crypto.randomUUID === 'function' ?
        window.crypto.randomUUID() :
        'hbc-waiver-' + Date.now() + '-' + Math.random().toString(36).slice(2);
    }
    trackBookingEvent(this, 'booking_submitted');
    this.waiverError = '';
    this.renderFlow();
    var junior = isJuniorGroup(this.selectedClass);
    var payload = junior ? {
      type: 'junior-waiver',
      requestId: this.waiverAttemptId,
      juniorFirstName: this.waiver.juniorFirstName,
      juniorLastName: this.waiver.juniorLastName,
      juniorDateOfBirth: this.waiver.juniorDateOfBirth,
      mobileContactNumber: this.waiver.mobileContactNumber,
      email: this.waiver.email,
      address: this.waiver.address,
      postcode: this.waiver.postcode,
      medicalConditionsOrInjuries: this.waiver.medicalConditionsOrInjuries,
      emergencyContactName: this.waiver.emergencyContactName,
      emergencyContactRelationship: this.waiver.emergencyContactRelationship,
      emergencyContactNumber: this.waiver.emergencyContactNumber,
      juniorPronouns: this.waiver.juniorPronouns,
      promotionalPhotoConsent: this.waiver.promotionalPhotoConsent,
      attendedBefore: this.waiver.attendedBefore,
      acquisitionSource: this.waiver.acquisitionSource,
      acquisitionSourceOther: this.waiver.acquisitionSourceOther,
      marketingConsent: this.waiver.marketingConsent === true,
      photoBase64: this.waiver.photoBase64,
      photoMimeType: this.waiver.photoMimeType,
      photoFileName: this.waiver.photoFileName,
      signedByParentOrGuardian: this.waiver.signedByParentOrGuardian
    } : {
      type: 'adult-waiver',
      requestId: this.waiverAttemptId,
      firstName: this.waiver.firstName,
      lastName: this.waiver.lastName,
      phone: this.waiver.phone,
      address: this.waiver.address,
      dateOfBirth: this.waiver.dateOfBirth,
      email: this.waiver.email,
      postcode: this.waiver.postcode,
      medicalConditionsOrInjuries: this.waiver.medicalConditionsOrInjuries,
      emergencyContactName: this.waiver.emergencyContactName,
      emergencyContactRelationship: this.waiver.emergencyContactRelationship,
      emergencyContactNumber: this.waiver.emergencyContactNumber,
      attendedBefore: this.waiver.attendedBefore,
      acquisitionSource: this.waiver.acquisitionSource,
      acquisitionSourceOther: this.waiver.acquisitionSourceOther,
      marketingConsent: this.waiver.marketingConsent === true,
      photoBase64: this.waiver.photoBase64,
      photoMimeType: this.waiver.photoMimeType,
      photoFileName: this.waiver.photoFileName,
      signedName: this.waiver.signedName
    };
    var waiverController = typeof AbortController === 'function' ? new AbortController() : null;
    var waiverTimer = waiverController ? window.setTimeout(function () {
      waiverController.abort();
    }, 45000) : null;
    var waiverRequest = this.cloudflareUrl ?
      postQueuedBookingPayload(this.cloudflareUrl, payload) :
      fetch(this.apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
        redirect: 'follow',
        credentials: 'omit',
        signal: waiverController ? waiverController.signal : undefined
      }).then(function (response) {
        if (!response.ok) throw new Error('request-failed');
        return response.json();
      });
    waiverRequest.then(function (data) {
      if (!data || data.ok !== true) {
        var backendError = new Error('waiver-rejected');
        backendError.publicMessage = data && typeof data.message === 'string' ? data.message : '';
        backendError.errorCode = data && typeof data.errorCode === 'string' ? data.errorCode : '';
        backendError.completedResponse = true;
        throw backendError;
      }
      self.waiverId = normaliseText(data.waiverId) || 'saved';
      self.waiverQrToken = normaliseText(data.customerQrToken);
      trackBookingEvent(self, 'waiver_completed');
      if (data.member) {
        self.customerProfile = {
          waiverFound: true,
          waiverId: self.waiverId,
          member: data.member
        };
      }
      self.details = junior ? {
        firstName: self.waiver.juniorFirstName,
        lastName: self.waiver.juniorLastName,
        phone: self.waiver.mobileContactNumber,
        email: self.waiver.email,
        attendedBefore: self.waiver.attendedBefore
      } : {
        firstName: self.waiver.firstName,
        lastName: self.waiver.lastName,
        phone: self.waiver.phone,
        email: self.waiver.email,
        attendedBefore: self.waiver.attendedBefore
      };
      rememberBookingDetails(self.details);
      var completedSignature = self.customerSignature();
      if (completedSignature) {
        var completedProfile = {
          ok: true,
          waiverFound: true,
          waiverId: self.waiverId,
          member: data.member || (self.customerProfile && self.customerProfile.member) || null
        };
        MEMBER_LOOKUP_CACHE.set(completedSignature, {
          data: completedProfile,
          savedAt: Date.now()
        });
        self.customerProfile = completedProfile;
        self.lookupSignature = completedSignature;
        self.lookupCompleteSignature = completedSignature;
      }
      if (waiverTimer) window.clearTimeout(waiverTimer);
      self.processingCompletionPending = true;
      self.submitting = false;
      if (self.context === 'standalone') {
        self.preStage = 'waiver-success';
        self.renderFlow();
        self.revealQrResult();
        self.announce('Waiver completed. Your waiver has been saved.');
        return;
      }
      self.preStage = 'booking';
      if (self.journey === 'one-to-one') {
        self.lookupPending = false;
        self.lookupCompleteSignature = self.customerSignature();
        self.personalStage = 'call-contact';
        self.renderFlow();
        self.announce('Waiver saved. Call the coach to agree your one-to-one session time.');
        return;
      }
      if (self.journey === 'membership') {
        self.lookupPending = false;
        self.lookupCompleteSignature = self.customerSignature();
        self.announce('Waiver saved. Reserving your membership now.');
        self.submitMembershipReservation();
        return;
      }
      self.step = 3;
      self.lookupPending = false;
      self.lookupCompleteSignature = self.customerSignature();
      self.announce('Waiver saved. Confirming your booking now.');
      self.submit();
    }).catch(function (error) {
      if (waiverTimer) window.clearTimeout(waiverTimer);
      self.submitting = false;
      if (error && error.completedResponse && error.errorCode === 'WAIVER_VALIDATION_FAILED') {
        self.waiverAttemptId = '';
      }
      self.waiverError = error.publicMessage || (error && error.name === 'AbortError' ?
        'The secure save took too long. Your details are still here—press Try saving again.' :
        'Your waiver could not be saved. Check your connection and try again.');
      self.renderFlow();
      self.announce(self.waiverError);
      trackBookingEvent(self, 'booking_failed');
    });
  };

  HbcBooking.prototype.renderWaiverSuccess = function () {
    var success = element('div', 'hbc-booking__step hbc-booking__success');
    success.dataset.qrResult = '';
    var icon = element('div', 'hbc-booking__success-icon hbc-booking__success-icon--green');
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<svg viewBox="0 0 48 48"><path d="M10 25l9 9 19-21"/></svg>';
    success.appendChild(icon);
    var junior = isJuniorGroup(this.selectedClass);
    var standalone = this.context === 'standalone';
    var successHeading = element('h3', '', standalone ?
      (junior ? 'Junior Waiver Completed' : 'Adult Waiver Completed') :
      'Waiver completed');
    successHeading.dataset.qrResultHeading = '';
    success.appendChild(successHeading);
    success.appendChild(element('p', '', standalone ?
      (junior ?
        'The junior waiver has been saved successfully. The participant is ready to take part in their session.' :
        'Your waiver has been saved successfully. You are ready to take part in your session.') :
      'Your waiver has been saved. You can now confirm your class booking.'));
    if (standalone && this.waiverId && this.waiverId !== 'saved') {
      success.appendChild(element('p', 'hbc-booking__booking-id', 'Waiver reference: ' + this.waiverId));
    }
    if (standalone && this.waiverQrToken) {
      var qrFigure = element('figure', 'hbc-booking__check-in-qr');
      qrFigure.dataset.qrImageResult = '';
      var qrImage = element('img');
      qrImage.src = 'https://quickchart.io/qr?size=300&margin=2&text=' +
        encodeURIComponent('HBC-CUSTOMER:' + this.waiverQrToken);
      qrImage.alt = 'Permanent Heathrow Boxing Club customer QR code';
      qrImage.width = 220;
      qrImage.height = 220;
      qrFigure.appendChild(qrImage);
      qrFigure.appendChild(element('figcaption', '',
        'THIS IS YOUR PERSONAL PERMANENT QR CODE. SAVE IT AND USE IT FOR EVERY CLASS.'));
      success.appendChild(qrFigure);
      success.appendChild(element('p', 'hbc-booking__qr-explanation',
        'Your waiver is complete. You must still book each class separately before using this QR code to check in.'));
    }
    var actions = element('div', 'hbc-booking__actions hbc-booking__actions--center');
    var button = element('button', 'hbc-booking__button', standalone ? 'Done' : 'Continue to booking');
    button.type = 'button';
    button.dataset.bookingAction = standalone ? 'standalone-done' : 'continue-after-waiver';
    actions.appendChild(button);
    success.appendChild(actions);
    return success;
  };

  HbcBooking.prototype.submit = function () {
    var self = this;
    if (this.submitting || !this.selectedClass || !this.selectedSession) return;
    var errors = this.validateDetails();
    if (Object.keys(errors).length) return this.showValidation(errors);
    var signature = this.customerSignature();
    if (!this.lookupPending && this.lookupCompleteSignature !== signature &&
      this.lookupState !== 'unavailable') this.lookupCustomer();
    if (this.lookupPending && this.lookupPromise) {
      var pendingLookup = this.lookupPromise;
      this.submitting = true;
      this.renderFlow();
      pendingLookup.finally(function () {
        self.submitting = false;
        self.renderFlow();
        self.submit();
      });
      return;
    }
    if (this.customerProfile && this.customerProfile.waiverFound === false) {
      trackBookingEvent(this, 'waiver_required');
      this.beginRequiredWaiver();
      return;
    }

    this.submitting = true;
    this.submissionError = '';
    this.bookingWaitLong = false;
    if (this.bookingWaitTimer) window.clearTimeout(this.bookingWaitTimer);
    this.bookingWaitTimer = window.setTimeout(function () {
      if (!self.submitting) return;
      self.bookingWaitLong = true;
      self.renderFlow();
    }, 4000);
    if (!this.bookingAttemptId) {
      this.bookingAttemptId = window.crypto && typeof window.crypto.randomUUID === 'function' ?
        window.crypto.randomUUID() :
        'hbc-' + Date.now() + '-' + Math.random().toString(36).slice(2);
    }
    this.renderFlow();
    var payload = {
      type: 'booking',
      firstName: this.details.firstName,
      lastName: this.details.lastName,
      phone: this.details.phone,
      email: this.details.email,
      classDate: this.selectedSession.date,
      className: this.selectedClass.name,
      bookingTime: this.selectedSession.time,
      price: this.selectedClass.price,
      requestId: this.bookingAttemptId,
      customerStatus: this.customerStatus,
      waiverId: this.waiverId,
      attendedBefore: this.details.attendedBefore
    };

    var bookingRequest = this.cloudflareUrl ?
      postQueuedBookingPayload(this.cloudflareUrl, payload) :
      postBookingPayload(this.apiUrl, payload, 0);
    bookingRequest.then(function (data) {
      if (!data || data.ok !== true) {
        var backendError = new Error('booking-rejected');
        backendError.publicMessage = data && typeof data.message === 'string' ? data.message : '';
        backendError.status = data && data.status;
        throw backendError;
      }
      if (self.bookingWaitTimer) window.clearTimeout(self.bookingWaitTimer);
      self.bookingWaitTimer = null;
      self.success = {
        bookingId: normaliseText(data.bookingId) || 'Confirmed',
        message: normaliseText(data.message),
        checkInToken: normaliseText(data.checkInToken),
        customerQrToken: normaliseText(data.customerQrToken),
        duplicate: data.duplicate === true,
        isMember: data.isMember === true,
        memberFirstName: normaliseText(data.memberFirstName),
        cancellationUrl: normaliseText(data.cancellationUrl),
        price: Number(data.price),
        loyaltyEnabled: data.loyaltyEnabled === true,
        loyaltyEligible: data.loyaltyEligible === true,
        loyaltyPaidAttendancesInCycle: Number(data.loyaltyPaidAttendancesInCycle || 0),
        loyaltyPaidAttendancesRequired: Number(data.loyaltyPaidAttendancesRequired || 10),
        loyaltyRewardAvailable: data.loyaltyRewardAvailable === true,
        loyaltyRewardBooking: data.loyaltyRewardBooking === true,
        loyaltyCycleNumber: Number(data.loyaltyCycleNumber || 1),
        sameDayBookingCount: Math.max(1, Number(data.sameDayBookingCount || 1)),
        email: normaliseText(self.details.email),
        performance: data.performance && typeof data.performance === 'object' ? data.performance : {},
        customerEmailFailed: Array.isArray(data.emailWarnings) &&
          data.emailWarnings.some(function (warning) {
            return normaliseText(warning).toLowerCase().includes('customer confirmation');
          })
      };
      self.step = 4;
      trackBookingEvent(self, 'booking_completed');
      self.processingCompletionPending = true;
      self.submitting = false;
      rememberBookingDetails(self.details);
      var remembered = savedBookingDetails() || {};
      self.details = {
        firstName: remembered.firstName || '', lastName: remembered.lastName || '',
        phone: displayUkMobile(remembered.phone), email: remembered.email || '', attendedBefore: ''
      };
      self.waiver = null;
      self.waiverId = '';
      self.waiverError = '';
      self.waiverAttemptId = '';
      self.bookingAttemptId = '';
      var renderStartedAt = window.performance && performance.now ? performance.now() : Date.now();
      self.renderFlow();
      self.revealQrResult();
      var renderEndedAt = window.performance && performance.now ? performance.now() : Date.now();
      self.success.performance.confirmationRenderMs = Math.round(renderEndedAt - renderStartedAt);
      if (window.console && typeof window.console.info === 'function') {
        console.info('HBC booking performance', self.success.performance);
      }
      self.announce('Booking confirmed for ' + self.selectedClass.name + ' on ' +
        longDate(self.selectedSession) + ' at ' + displaySessionTime(self.selectedSession.time) + '.');
    }).catch(function (error) {
      if (self.bookingWaitTimer) window.clearTimeout(self.bookingWaitTimer);
      self.bookingWaitTimer = null;
      self.bookingWaitLong = false;
      self.submitting = false;
      if (error.status === 'waiver-required') {
        trackBookingEvent(self, 'waiver_required');
        self.beginRequiredWaiver();
        return;
      }
      self.submissionError = error.publicMessage ||
        'We could not complete the booking just now. Your details are still here and no duplicate booking will be created. Please wait a moment and press Confirm Booking again.';
      self.renderFlow();
      self.announce(self.submissionError);
      trackBookingEvent(self, 'booking_failed');
    });
  };

  HbcBooking.prototype.beginRequiredWaiver = function () {
    var junior = isJuniorGroup(this.selectedClass);
    this.waiver = junior ? emptyJuniorWaiver() : emptyAdultWaiver();
    this.waiverValidationErrors = {};
    this.photoPreparationId += 1;
    this.photoPreparing = false;
    if (junior) {
      this.waiver.juniorFirstName = this.details.firstName;
      this.waiver.juniorLastName = this.details.lastName;
      this.waiver.mobileContactNumber = this.details.phone;
      this.waiver.email = this.details.email;
      this.preStage = 'junior-waiver';
    } else {
      this.waiver.firstName = this.details.firstName;
      this.waiver.lastName = this.details.lastName;
      this.waiver.phone = this.details.phone;
      this.waiver.email = this.details.email;
      this.preStage = 'adult-waiver';
    }
    this.waiverError = 'No matching online waiver was found. Complete this form once, then your selected booking will continue.';
    this.renderFlow();
    this.announce('Complete the online waiver to continue your booking.');
  };

  HbcBooking.prototype.renderSuccess = function () {
    var success = element('div', 'hbc-booking__step hbc-booking__success hbc-booking__success--premium');
    success.dataset.qrResult = '';
    var hero = element('header', 'hbc-booking__success-hero');
    var icon = element('div', 'hbc-booking__success-icon');
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<svg viewBox="0 0 48 48"><path d="M10 25l9 9 19-21"/></svg>';
    hero.appendChild(icon);
    var successHeading = element(
      'h3',
      '',
      this.success.duplicate ?
        'Booking already confirmed' :
        (this.success.isMember ?
          'Welcome back, ' + (this.success.memberFirstName || 'member') :
          'You’re booked')
    );
    successHeading.dataset.qrResultHeading = '';
    hero.appendChild(successHeading);
    hero.appendChild(element('p', 'hbc-booking__success-class', this.selectedClass.name));
    hero.appendChild(element('p', 'hbc-booking__success-when',
      longDate(this.selectedSession) + ' · ' + displaySessionTime(this.selectedSession.time)));
    success.appendChild(hero);
    if (this.success.duplicate) {
      success.appendChild(element(
        'p',
        'hbc-booking__submission-notice',
        'You already have an active booking for this class. No duplicate booking was created. Your original QR code is shown below.'
      ));
    }

    var sessionCard = element('section', 'hbc-booking__success-card hbc-booking__session-pass');
    sessionCard.appendChild(element('p', 'hbc-booking__success-kicker', 'Your session'));
    var sessionGrid = element('div', 'hbc-booking__session-pass-grid');
    [["Class", this.selectedClass.name], ["Date", longDate(this.selectedSession)],
      ["Time", displaySessionTime(this.selectedSession.time)]].forEach(function (item) {
      var detail = element('div');
      detail.append(element('span', '', item[0]), element('strong', '', item[1]));
      sessionGrid.appendChild(detail);
    });
    sessionCard.appendChild(sessionGrid);
    var payment = element('div', 'hbc-booking__payment-state');
    if (this.success.isMember) {
      payment.append(element('span', '', 'Covered by membership'), element('strong', '', 'Nothing to pay'));
      payment.classList.add('is-covered');
    } else if (this.success.loyaltyRewardBooking) {
      payment.append(element('span', '', 'Loyalty reward'), element('strong', '', '£0 due'));
      payment.classList.add('is-covered');
    } else if (Number(this.success.price) > 0) {
      payment.append(element('span', '', 'Payment at the club'),
        element('strong', '', formatMoney(this.success.price) + ' cash on arrival'));
      payment.appendChild(element('p', '', 'Your place is reserved. Pay when you arrive, then scan your HBC QR.'));
    } else {
      payment.append(element('span', '', 'Payment'), element('strong', '', 'Nothing to pay'));
      payment.classList.add('is-covered');
    }
    sessionCard.appendChild(payment);
    success.appendChild(sessionCard);

    if (this.success.customerQrToken || this.success.checkInToken) {
      var qrCard = element('section', 'hbc-booking__success-card hbc-booking__qr-card');
      qrCard.appendChild(element('p', 'hbc-booking__success-kicker', 'Your HBC pass'));
      qrCard.appendChild(element('h4', '', 'One QR. Every visit.'));
      qrCard.appendChild(element('p', 'hbc-booking__card-copy',
        'Save your permanent HBC QR and bring it whenever you train. You still need to book each class.'));
      var qrFigure = element('figure', 'hbc-booking__check-in-qr');
      qrFigure.dataset.qrImageResult = '';
      var qrImage = element('img');
      var qrValue = this.success.customerQrToken ?
        'HBC-CUSTOMER:' + this.success.customerQrToken :
        'HBC-CHECKIN:' + this.success.checkInToken;
      qrImage.src = 'https://quickchart.io/qr?size=300&margin=2&text=' +
        encodeURIComponent(qrValue);
      qrImage.alt = this.success.customerQrToken ?
        'Permanent Heathrow Boxing Club customer QR code' :
        'QR code for checking in to this booking';
      qrImage.width = 220;
      qrImage.height = 220;
      qrImage.loading = 'eager';
      qrImage.decoding = 'async';
      qrImage.dataset.bookingQrImage = '';
      qrFigure.appendChild(qrImage);
      qrFigure.appendChild(element(
        'figcaption',
        '',
        this.success.customerQrToken ?
          'Your permanent HBC QR' : 'Your booking QR'
      ));
      qrCard.appendChild(qrFigure);
      var saveQr = element('button',
        'hbc-booking__button hbc-booking__button--secondary hbc-booking__save-qr', 'Save QR');
      saveQr.type = 'button';
      saveQr.dataset.bookingAction = 'save-qr';
      qrCard.appendChild(saveQr);
      if (this.success.sameDayBookingCount > 1) {
        qrCard.appendChild(element('p', 'hbc-booking__multi-session',
          'Multiple classes today? Scan this QR once at each class. One check-in applies to one session.'));
      }
      success.appendChild(qrCard);
    }

    var supportGrid = element('div', 'hbc-booking__success-support');
    if (this.success.loyaltyEnabled && this.success.loyaltyEligible && !this.success.isMember) {
      supportGrid.appendChild(this.renderLoyaltyProgress());
    }
    var arrival = element('section', 'hbc-booking__success-card hbc-booking__arrival');
    arrival.appendChild(element('p', 'hbc-booking__success-kicker', 'Before you arrive'));
    var checklist = element('ul', 'hbc-booking__arrival-list');
    ['Bring water', 'Bring a towel', 'Bring your gloves where possible'].forEach(function (item) {
      checklist.appendChild(element('li', '', item));
    });
    arrival.appendChild(checklist);
    arrival.appendChild(element('p', 'hbc-booking__card-copy', 'First session? Gloves can be lent if needed.'));
    supportGrid.appendChild(arrival);
    success.appendChild(supportGrid);

    var emailStatus = this.success.customerEmailFailed ?
      'Your booking is confirmed, but the confirmation email could not be sent. Save the QR code shown above.' :
      (this.success.duplicate ?
        'Check your email for the original confirmation. If it has not arrived, save the QR code shown above.' :
        'Confirmation sent. Can’t see it? Check your junk folder.');
    var emailCard = element('p', this.success.customerEmailFailed || this.success.duplicate ?
      'hbc-booking__email-state is-warning' : 'hbc-booking__email-state', emailStatus);
    var maskedEmail = maskEmail(this.success.email);
    if (!this.success.customerEmailFailed && !this.success.duplicate && maskedEmail) {
      emailCard.appendChild(element('span', '', ' ' + maskedEmail));
    }
    success.appendChild(emailCard);
    var privacy = element('p', 'hbc-booking__privacy', 'Your booking is handled under our ');
    var privacyLink = element('a', '', 'Privacy Policy');
    privacyLink.href = this.root.dataset.privacyUrl || '/policies/privacy-policy';
    privacyLink.target = '_blank';
    privacyLink.rel = 'noopener';
    privacy.appendChild(privacyLink);
    privacy.appendChild(document.createTextNode('.'));
    success.appendChild(privacy);
    if (this.success.cancellationUrl) {
      var cancellationNotice = element(
        'p',
        'hbc-booking__cancellation-notice',
        'Can’t make it? Please cancel so someone else can take your place.'
      );
      var cancellationLink = element(
        'a',
        'hbc-booking__button hbc-booking__button--secondary',
        'Cancel booking'
      );
      cancellationLink.href = this.success.cancellationUrl;
      cancellationLink.target = '_blank';
      cancellationLink.rel = 'noopener';
      success.append(cancellationNotice, cancellationLink);
    }
    var actions = element('div', 'hbc-booking__actions');
    var another = element('button', 'hbc-booking__button', 'Book Another Class');
    another.type = 'button';
    another.dataset.bookingAction = 'book-another';
    actions.appendChild(another);
    if (this.mode === 'compact') {
      var close = element('button', 'hbc-booking__button hbc-booking__button--secondary', 'Close');
      close.type = 'button';
      close.dataset.bookingAction = 'close-success';
      actions.appendChild(close);
    }
    success.appendChild(actions);
    return success;
  };

  HbcBooking.prototype.renderLoyaltyProgress = function () {
    var paid = Math.max(0, Math.min(10, Number(this.success.loyaltyPaidAttendancesInCycle || 0)));
    var rewardBooking = Boolean(this.success.loyaltyRewardBooking);
    var block = element('section', 'hbc-booking__loyalty');
    block.setAttribute('aria-live', 'polite');
    block.appendChild(element('p', 'hbc-booking__loyalty-kicker', 'PAYG loyalty'));
    block.appendChild(element('h4', '', rewardBooking ? 'Reward booked' : paid + ' / 10'));
    var track = element('ol', 'hbc-booking__loyalty-track');
    track.setAttribute('aria-label', paid + ' of 10 paid classes completed. This booking is pending attendance.');
    for (var position = 1; position <= 11; position += 1) {
      var item = element('li', position === 11 ? 'is-reward' : '');
      if (position <= paid) item.classList.add('is-complete');
      if (!rewardBooking && position === paid + 1 && position <= 10) item.classList.add('is-pending');
      if (rewardBooking && position === 11) item.classList.add('is-pending', 'is-unlocked');
      var node = element('span', 'hbc-booking__loyalty-node', position === 11 ? 'FREE' : '');
      item.appendChild(node);
      if (item.classList.contains('is-complete')) {
        node.textContent = '✓';
        node.setAttribute('aria-label', 'Class ' + position + ' completed');
      } else if (item.classList.contains('is-pending')) {
        node.setAttribute('aria-label', position === 11 ? 'Free class booked, pending check-in' :
          'Class ' + position + ' booked, pending check-in');
      }
      track.appendChild(item);
    }
    block.appendChild(track);
    block.appendChild(element('p', 'hbc-booking__loyalty-pending', rewardBooking ?
      'Reward is redeemed after check-in.' : 'Next stamp added after successful check-in.'));
    block.appendChild(element('p', 'hbc-booking__loyalty-terms',
      '10 eligible paid attendances = your next eligible class free.'));
    return block;
  };

  HbcBooking.prototype.openOneToOne = function (trigger) {
    this.trigger = trigger;
    this.journey = 'one-to-one';
    trackBookingEvent(this, 'one_to_one_opened');
    this.personalStage = 'personal-intro';
    this.personalPlan = emptyOneToOnePlan();
    this.personalAvailability = [];
    this.personalCalendarDays = [];
    this.personalAvailabilityLoaded = false;
    this.personalCalendarDate = '';
    this.personalError = '';
    this.selectedClass = { key: 'one-to-one', name: ONE_TO_ONE.name, price: 60, minimumAge: 18, levels: ['Personal coaching'], timetable: [] };
    this.selectedSession = null;
    this.success = null;
    this.preStage = 'booking';
    var dialogTitle = this.root.querySelector('[id^="hbc-booking-dialog-title-"]');
    if (dialogTitle) dialogTitle.textContent = 'Book One-to-One Coaching';
    if (this.mode === 'compact') this.openModal();
    else {
      this.root.querySelector('[data-booking-flow]').hidden = false;
      this.renderFlow();
      this.root.querySelector('[data-booking-flow]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  HbcBooking.prototype.openMembership = function (trigger) {
    this.trigger = trigger;
    this.journey = 'membership';
    trackBookingEvent(this, 'membership_opened');
    this.membershipStage = 'membership-intro';
    this.membershipError = '';
    this.selectedClass = { key: 'membership', name: MEMBERSHIP.name, price: 130, minimumAge: 18, levels: ['Adult'], timetable: [] };
    this.selectedSession = null;
    this.success = null;
    this.preStage = 'booking';
    this.bookingAttemptId = '';
    var title = this.root.querySelector('[id^="hbc-booking-dialog-title-"]');
    if (title) title.textContent = 'Reserve Your Membership';
    if (this.mode === 'compact') this.openModal();
    else {
      this.root.querySelector('[data-booking-flow]').hidden = false;
      this.renderFlow();
      this.root.querySelector('[data-booking-flow]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  HbcBooking.prototype.membershipProgress = function () {
    var stages = ['membership-intro', 'membership-details', 'membership-checking', 'membership-review', 'membership-submitting', 'membership-success'];
    var current = Math.max(0, stages.indexOf(this.membershipStage));
    var wrapper = element('div', 'hbc-booking__personal-progress');
    wrapper.appendChild(element('span', '', this.membershipStage === 'membership-success' ? 'Complete' : 'Step ' + Math.min(3, current + 1) + ' of 3'));
    var track = element('span', 'hbc-booking__personal-progress-track');
    var fill = element('span', 'hbc-booking__personal-progress-fill');
    fill.style.width = (this.membershipStage === 'membership-success' ? 100 : Math.min(100, (current + 1) / 3 * 100)) + '%';
    track.appendChild(fill); wrapper.appendChild(track); return wrapper;
  };

  HbcBooking.prototype.renderMembershipFields = function () {
    var fields = element('div', 'hbc-booking__fields'); var self = this;
    [{key:'firstName',label:'First name',type:'text',autocomplete:'given-name'},
      {key:'lastName',label:'Last name',type:'text',autocomplete:'family-name'},
      {key:'phone',label:'UK mobile number (+44, omit the first 0)',type:'tel',autocomplete:'tel'},
      {key:'email',label:'Email address',type:'email',autocomplete:'email'}].forEach(function(def){
      var field=element('div','hbc-booking__field'),id='hbc-'+self.root.dataset.hbcBookingSection+'-membership-'+def.key;
      var label=element('label','',def.label),input=element('input'),error=element('p','hbc-booking__field-error');
      label.htmlFor=id;input.id=id;input.type=def.type;input.autocomplete=def.autocomplete;input.required=true;
      input.value=self.details[def.key]||'';input.dataset.bookingField=def.key;error.dataset.errorFor=def.key;
      field.append(label,input,error);fields.appendChild(field);
    });
    return fields;
  };

  HbcBooking.prototype.renderMembershipFlow = function () {
    if (this.membershipStage === 'membership-success') {
      var success=element('div','hbc-booking__step hbc-booking__success');
      success.appendChild(element('h3','','Membership Spot Reserved'));
      success.appendChild(element('p','hbc-booking__submission-notice','This is a reservation, not an active membership yet.'));
      success.appendChild(element('p','','Tell the coach when you arrive for your next session. You will pay £130 at the club, and the coach will activate your membership month after the session.'));
      success.appendChild(element('p','','Check your email and show the membership reservation confirmation to the coach when you arrive. Check your spam or junk folder if it is not in your inbox.'));
      success.appendChild(element('strong','hbc-booking__membership-book-class','YOU MUST STILL BOOK THE CLASS YOU WANT TO ATTEND.'));
      var bookLink=element('a','hbc-booking__button','Book a Class');bookLink.href='/pages/book-a-class#book';success.appendChild(bookLink);
      success.appendChild(element('p','hbc-booking__membership-fine-print','Membership payments are non-refundable once the coach activates the membership.'));
      success.appendChild(this.personalActions(null,'close-success','Close'));
      return success;
    }
    var step=element('div','hbc-booking__step hbc-booking__membership-step');
    if(this.membershipStage==='membership-intro'){
      step.appendChild(element('p','hbc-booking__eyebrow','Train consistently'));
      step.appendChild(element('h3','hbc-booking__step-heading','Monthly Unlimited Membership'));
      step.appendChild(element('p','hbc-booking__personal-price','£130 monthly'));
      var benefits=element('ul','hbc-booking__membership-benefits');
      ['All scheduled group classes included during your active membership month','No class-by-class payment while your membership is active','Pay and complete setup with the coach at the club'].forEach(function(text){benefits.appendChild(element('li','',text));});
      step.appendChild(benefits);
      step.appendChild(element('p','hbc-booking__submission-notice','You are only reserving your membership here. No payment is taken online. Membership payments are non-refundable once activated.'));
      step.appendChild(this.personalActions('personal-close','membership-details','Reserve My Membership'));
    }else if(this.membershipStage==='membership-details'){
      step.appendChild(element('h3','hbc-booking__step-heading','Your details'));
      step.appendChild(element('p','hbc-booking__step-copy','Enter a few basic details. We will quietly check whether you already have an online waiver with us.'));
      step.appendChild(this.renderMembershipFields());
      if(this.membershipError)step.appendChild(element('div','hbc-booking__submission-error',this.membershipError));
      step.appendChild(this.personalActions('membership-intro','membership-review','Continue'));
    }else if(this.membershipStage==='membership-checking'){
      step.appendChild(element('h3','hbc-booking__step-heading','Checking your details'));
      step.appendChild(element('p','hbc-booking__step-copy','One moment. We are getting your reservation ready.'));
    }else if(this.membershipStage==='membership-review'||this.membershipStage==='membership-submitting'){
      step.appendChild(element('h3','hbc-booking__step-heading','Reserve Your Membership'));
      var card=element('div','hbc-booking__personal-review');
      [this.details.firstName+' '+this.details.lastName,MEMBERSHIP.name,'£130 monthly','Pay at the club'].forEach(function(value){card.appendChild(element('p','',value));});
      step.appendChild(card);
      step.appendChild(element('p','hbc-booking__submission-notice','When you arrive, tell the coach that you reserved a membership. Pay at the club and the coach will complete your setup and activate the month. This reservation itself is not an active membership.'));
      step.appendChild(element('p','hbc-booking__membership-fine-print','Monthly membership payments are non-refundable once activated.'));
      if(this.membershipError)step.appendChild(element('div','hbc-booking__submission-error',this.membershipError));
      step.appendChild(this.personalActions('membership-details','membership-submit',this.submitting?'Reserving...':'Confirm Reservation',this.submitting));
    }
    return step;
  };

  HbcBooking.prototype.handleMembershipAction = function (action) {
    if(action==='membership-intro'){this.membershipStage='membership-intro';this.renderFlow();return;}
    if(action==='membership-details'){this.membershipStage='membership-details';this.renderFlow();return;}
    if(action==='membership-review'){
      var errors=this.validateDetails();if(Object.keys(errors).length)return this.showValidation(errors);
      this.membershipStage='membership-checking';this.renderFlow();
      var self=this;
      this.fastCustomerLookup({firstName:this.details.firstName,lastName:this.details.lastName,phone:this.details.phone,email:this.details.email})
        .then(function(data){
          if(!data||!data.ok)throw new Error();self.customerProfile=data;self.waiverId=data.waiverFound?normaliseText(data.waiverId):'';
          if(!self.waiverId){self.waiver=emptyAdultWaiver();self.waiver.firstName=self.details.firstName;self.waiver.lastName=self.details.lastName;self.waiver.phone=self.details.phone;self.waiver.email=self.details.email;self.preStage='adult-waiver';}
          else self.membershipStage='membership-review';self.renderFlow();
        }).catch(function(){self.membershipStage='membership-details';self.membershipError='We could not check your details. Please try again.';self.renderFlow();});return;
    }
    if(action==='membership-submit')return this.submitMembershipReservation();
  };

  HbcBooking.prototype.submitMembershipReservation = function () {
    var self=this;if(this.submitting)return;this.submitting=true;this.membershipStage='membership-submitting';this.membershipError='';
    if(!this.bookingAttemptId)this.bookingAttemptId=window.crypto&&window.crypto.randomUUID?window.crypto.randomUUID():'hbc-'+Date.now();this.renderFlow();
    var payload={type:'membership-reservation',firstName:this.details.firstName,lastName:this.details.lastName,phone:this.details.phone,email:this.details.email,requestId:this.bookingAttemptId,waiverId:this.waiverId};
    var request=this.cloudflareUrl?postQueuedBookingPayload(this.cloudflareUrl,payload):postBookingPayload(this.apiUrl,payload,0);
    request.then(function(data){if(!data||!data.ok){var e=new Error();e.status=data&&data.status;e.publicMessage=data&&data.message;throw e;}self.processingCompletionPending=true;self.submitting=false;self.success=data;self.membershipStage='membership-success';rememberBookingDetails(self.details);self.renderFlow();})
      .catch(function(error){self.submitting=false;if(error.status==='waiver-required'){self.waiver=emptyAdultWaiver();self.waiver.firstName=self.details.firstName;self.waiver.lastName=self.details.lastName;self.waiver.phone=self.details.phone;self.waiver.email=self.details.email;self.preStage='adult-waiver';self.renderFlow();return;}self.membershipStage='membership-review';self.membershipError=error.publicMessage||'We could not reserve your membership. Please try again.';self.renderFlow();});
  };

  HbcBooking.prototype.personalProgress = function () {
    var stages = ['personal-intro', 'primary-goal', 'experience', 'focus-areas', 'health', 'preferences', 'plan-summary', 'customer-details', 'customer-checking', 'call-contact', 'call-pending'];
    var current = Math.max(0, stages.indexOf(this.personalStage));
    var visibleStep = Math.min(7, Math.max(1, current));
    var wrapper = element('div', 'hbc-booking__personal-progress');
    wrapper.setAttribute('aria-label', 'One-to-one booking progress');
    wrapper.appendChild(element('span', '', this.personalStage === 'call-pending' ? 'Final step' : 'Step ' + visibleStep + ' of 7'));
    var track = element('span', 'hbc-booking__personal-progress-track');
    var fill = element('span', 'hbc-booking__personal-progress-fill');
    fill.style.width = (this.personalStage === 'call-pending' ? 100 : (visibleStep / 7 * 100)) + '%';
    track.appendChild(fill); wrapper.appendChild(track);
    return wrapper;
  };

  HbcBooking.prototype.personalButton = function (label, action, secondary) {
    var button = element('button', 'hbc-booking__button' + (secondary ? ' hbc-booking__button--text' : ''), label);
    button.type = 'button'; button.dataset.bookingAction = action; return button;
  };

  HbcBooking.prototype.personalChoices = function (options, key, multiple, limit) {
    var self = this; var grid = element('div', 'hbc-booking__personal-choices');
    options.forEach(function (option) {
      var selected = multiple ? self.personalPlan[key].indexOf(option) !== -1 :
        (key === 'hasHealthConsiderations' ? self.personalPlan[key] === (option === 'Yes') : self.personalPlan[key] === option);
      var button = element('button', 'hbc-booking__personal-choice' + (selected ? ' is-selected' : ''), option);
      button.type = 'button'; button.dataset.personalChoice = key; button.dataset.personalValue = option;
      button.dataset.personalMultiple = multiple ? 'true' : 'false';
      if (multiple) button.dataset.personalLimit = String(limit || 5);
      button.setAttribute('aria-pressed', String(selected)); grid.appendChild(button);
    });
    return grid;
  };

  HbcBooking.prototype.selectPersonalChoice = function (button) {
    var key = button.dataset.personalChoice; var value = button.dataset.personalValue;
    var dialog = this.root.querySelector('.hbc-booking__dialog');
    var flowContainer = this.root.querySelector('[data-booking-flow]');
    var dialogTop = dialog ? dialog.scrollTop : 0;
    var flowTop = flowContainer ? flowContainer.scrollTop : 0;
    if (key === 'calendar-date') {
      this.personalCalendarDate = value;
      this.renderFlow();
      return;
    }
    if (key === 'session') {
      var parts = value.split('T');
      var source = this.personalAvailability.find(function (item) { return item.date === parts[0] && item.time === parts[1]; });
      this.selectedSession = source || { date: parts[0], time: parts[1] };
      this.personalStage = 'booking-review';
      this.cancellationAccepted = false;
      this.renderFlow();
      return;
    }
    if (button.dataset.personalMultiple === 'true') {
      var values = this.personalPlan[key].slice(); var index = values.indexOf(value);
      var limit = Number(button.dataset.personalLimit || 5);
      if (index !== -1) values.splice(index, 1); else if (values.length < limit) values.push(value);
      this.personalPlan[key] = values;
    } else {
      this.personalPlan[key] = value;
      if (key === 'hasHealthConsiderations') this.personalPlan[key] = value === 'Yes';
    }
    this.renderFlow();
    window.requestAnimationFrame(function () {
      if (dialog) dialog.scrollTop = dialogTop;
      if (flowContainer) flowContainer.scrollTop = flowTop;
    });
  };

  HbcBooking.prototype.personalActions = function (backAction, nextAction, nextLabel, disabled) {
    var actions = element('div', 'hbc-booking__actions hbc-booking__personal-actions');
    if (backAction) actions.appendChild(this.personalButton('Back', backAction, true));
    if (nextAction) {
      var next = this.personalButton(nextLabel || 'Continue', nextAction, false);
      next.disabled = Boolean(disabled);
      actions.appendChild(next);
    }
    return actions;
  };

  HbcBooking.prototype.personalTextField = function (key, label, textarea, help) {
    var field = element('div', 'hbc-booking__field hbc-booking__field--wide');
    var id = 'hbc-' + this.root.dataset.hbcBookingSection + '-personal-' + key;
    var labelNode = element('label', '', label); labelNode.htmlFor = id;
    var input = element(textarea ? 'textarea' : 'input'); input.id = id; input.dataset.personalField = key;
    input.value = this.personalPlan[key] || ''; input.maxLength = textarea ? 500 : 160;
    if (textarea) input.rows = 4;
    field.append(labelNode, input); if (help) field.appendChild(element('small', 'hbc-booking__field-help', help)); return field;
  };

  HbcBooking.prototype.renderPersonalFlow = function () {
    if (this.personalStage === 'call-contact') return this.renderPersonalCallStep();
    if (this.personalStage === 'call-pending') return this.renderPersonalCallReturn();
    var step = element('div', 'hbc-booking__step hbc-booking__personal-step');
    var plan = this.personalPlan;
    if (this.personalStage === 'personal-intro') {
      step.appendChild(element('p', 'hbc-booking__eyebrow', 'One-to-one coaching'));
      step.appendChild(element('h3', 'hbc-booking__step-heading', 'Build Your Personal Training Plan'));
      step.appendChild(element('p', 'hbc-booking__step-copy', 'Every one-to-one session is tailored to your goals, experience and fitness level. Answer a few quick questions so your coach can prepare for your session.'));
      step.appendChild(element('p', 'hbc-booking__personal-time', 'Takes around 30-60 seconds'));
      step.appendChild(this.personalActions('personal-close', 'personal-goal', 'Build My Plan'));
    } else if (this.personalStage === 'primary-goal') {
      step.appendChild(element('h3', 'hbc-booking__step-heading', 'What are your main goals?'));
      step.appendChild(element('p', 'hbc-booking__step-copy', 'Choose up to three priorities.'));
      step.appendChild(this.personalChoices(ONE_TO_ONE.goals, 'primaryGoals', true, 3));
      if (plan.primaryGoals.indexOf('Something else') !== -1) step.appendChild(this.personalTextField('customGoal', 'Tell us what you would like to achieve', false));
      step.appendChild(this.personalActions('personal-intro', 'personal-experience', 'Continue', !plan.primaryGoals.length || (plan.primaryGoals.indexOf('Something else') !== -1 && !normaliseText(plan.customGoal))));
    } else if (this.personalStage === 'experience') {
      step.appendChild(element('h3', 'hbc-booking__step-heading', 'Your current level'));
      step.appendChild(element('h4', 'hbc-booking__personal-question', 'What is your boxing experience?'));
      step.appendChild(this.personalChoices(ONE_TO_ONE.experience, 'boxingExperience', false));
      step.appendChild(element('h4', 'hbc-booking__personal-question', 'How would you describe your current fitness?'));
      step.appendChild(this.personalChoices(ONE_TO_ONE.fitness, 'fitnessLevel', false));
      step.appendChild(this.personalActions('personal-goal', 'personal-focus', 'Continue', !plan.boxingExperience || !plan.fitnessLevel));
    } else if (this.personalStage === 'focus-areas') {
      step.appendChild(element('h3', 'hbc-booking__step-heading', 'What would you most like to work on?'));
      step.appendChild(element('p', 'hbc-booking__step-copy', 'Choose up to two areas. Your coach will combine the right exercises within each area.'));
      step.appendChild(this.personalChoices(ONE_TO_ONE.focus, 'focusAreas', true, 2));
      if (plan.focusAreas.indexOf('Something else') !== -1) step.appendChild(this.personalTextField('customFocus', 'What would you like to work on?', false));
      step.appendChild(this.personalActions('personal-experience', 'personal-health', 'Continue', !plan.focusAreas.length || (plan.focusAreas.indexOf('Something else') !== -1 && !normaliseText(plan.customFocus))));
    } else if (this.personalStage === 'health') {
      step.appendChild(element('h3', 'hbc-booking__step-heading', 'Health and movement'));
      step.appendChild(element('p', 'hbc-booking__step-copy', 'Are there any injuries, medical conditions or movement limitations your coach should know about?'));
      step.appendChild(this.personalChoices(['No', 'Yes'], 'hasHealthConsiderations', false));
      if (plan.hasHealthConsiderations === true) step.appendChild(this.personalTextField('healthConsiderations', 'Please briefly explain anything that may affect your training', true, 'For example: asthma, a previous shoulder injury, recent surgery or limited movement. This helps your coach adapt the session safely.'));
      step.appendChild(this.personalActions('personal-focus', 'personal-preferences', 'Continue', plan.hasHealthConsiderations === null || (plan.hasHealthConsiderations && !normaliseText(plan.healthConsiderations))));
    } else if (this.personalStage === 'preferences') {
      step.appendChild(element('h3', 'hbc-booking__step-heading', 'Training preferences'));
      step.appendChild(element('h4', 'hbc-booking__personal-question', 'How often are you hoping to train?'));
      step.appendChild(this.personalChoices(ONE_TO_ONE.frequency, 'trainingFrequency', false));
      step.appendChild(element('h4', 'hbc-booking__personal-question', 'What is your age range?'));
      step.appendChild(this.personalChoices(ONE_TO_ONE.ages, 'ageRange', false));
      if (plan.ageRange === 'Under 16' || plan.ageRange === '16-17') step.appendChild(element('p', 'hbc-booking__submission-notice', 'A parent or legal guardian must complete the booking and junior waiver where required.'));
      step.appendChild(element('h4', 'hbc-booking__personal-question', 'Is this your first time at Heathrow Boxing Club?'));
      step.appendChild(this.personalChoices(['Yes', 'No'], 'firstTime', false));
      step.appendChild(this.personalTextField('additionalNotes', 'Anything else you would like your coach to know? (optional)', true, 'Mention an upcoming event, previous training experience or anything you feel nervous about.'));
      step.appendChild(this.personalActions('personal-health', 'personal-summary', 'Review My Plan', !plan.trainingFrequency || !plan.ageRange || !plan.firstTime));
    } else if (this.personalStage === 'plan-summary') {
      step.appendChild(element('h3', 'hbc-booking__step-heading', 'Your Personal Coaching Plan'));
      step.appendChild(this.renderPersonalSummary());
      step.appendChild(element('p', 'hbc-booking__step-copy', 'Your coach will use this information to tailor the session around your goals and current level.'));
      step.appendChild(this.personalActions('personal-preferences', 'personal-details', 'Continue'));
    } else if (this.personalStage === 'customer-details') {
      step.appendChild(this.renderPersonalDetails());
    } else if (this.personalStage === 'customer-checking') {
      step.appendChild(element('h3', 'hbc-booking__step-heading', 'Checking your details'));
      step.appendChild(element('p', 'hbc-booking__step-copy', 'One moment. We are checking your online waiver before the final call step.'));
    } else if (this.personalStage === 'session-selection') {
      step.appendChild(this.renderPersonalSessions());
    } else if (this.personalStage === 'booking-review' || this.personalStage === 'booking-submitting') {
      step.appendChild(this.renderPersonalReview());
    }
    return step;
  };

  HbcBooking.prototype.renderPersonalSummary = function () {
    var card = element('dl', 'hbc-booking__personal-summary'); var self = this;
    var goals = self.personalPlan.primaryGoals.map(function (goal) { return goal === 'Something else' ? self.personalPlan.customGoal : goal; });
    var focuses = self.personalPlan.focusAreas.map(function (focus) { return focus === 'Something else' ? self.personalPlan.customFocus : focus; });
    [['Main goals', goals.join(', ')], ['Experience', self.personalPlan.boxingExperience], ['Fitness', self.personalPlan.fitnessLevel], ['Training focus', focuses.join(', ')], ['Training frequency', self.personalPlan.trainingFrequency]].forEach(function (row) {
      card.append(element('dt', '', row[0]), element('dd', '', row[1]));
    });
    card.appendChild(element('p', 'hbc-booking__personal-price', '£60 per 1-hour session')); return card;
  };

  HbcBooking.prototype.renderPersonalDetails = function () {
    var wrapper = element('div'); wrapper.appendChild(element('h3', 'hbc-booking__step-heading', 'Your details'));
    wrapper.appendChild(element('p', 'hbc-booking__step-copy', 'We will securely check your existing online waiver.'));
    var fields = element('div', 'hbc-booking__fields'); var self = this;
    [{ key:'firstName',label:'First name',type:'text',autocomplete:'given-name'},{key:'lastName',label:'Last name',type:'text',autocomplete:'family-name'},{key:'phone',label:'UK mobile number (+44, omit the first 0)',type:'tel',autocomplete:'tel'},{key:'email',label:'Email address',type:'email',autocomplete:'email'}].forEach(function(def){
      var field=element('div','hbc-booking__field'),id='hbc-'+self.root.dataset.hbcBookingSection+'-personal-detail-'+def.key,label=element('label','',def.label),input=element('input'),error=element('p','hbc-booking__field-error');
      label.htmlFor=id; input.id=id; input.type=def.type; input.autocomplete=def.autocomplete; input.required=true; input.value=self.details[def.key]||''; input.dataset.bookingField=def.key; error.dataset.errorFor=def.key; field.append(label,input,error); fields.appendChild(field);
    });
    wrapper.appendChild(fields); if(this.personalError) wrapper.appendChild(element('div','hbc-booking__submission-error',this.personalError));
    wrapper.appendChild(this.personalActions('personal-summary','personal-sessions','Continue to Final Step')); return wrapper;
  };

  HbcBooking.prototype.personalCallScript = function () {
    var goals=this.personalPlan.primaryGoals.map(function(goal){return goal==='Something else'?this.personalPlan.customGoal:goal;},this).join(', ');
    var focuses=this.personalPlan.focusAreas.map(function(focus){return focus==='Something else'?this.personalPlan.customFocus:focus;},this).join(', ');
    return 'Hi Serge, my name is '+this.details.firstName+' '+this.details.lastName+'. I would like to arrange a one-to-one session. My main goals are '+goals+'. I would especially like to work on '+focuses+'. Could we agree a suitable date and time?';
  };

  HbcBooking.prototype.renderPersonalCallStep = function () {
    var step=element('div','hbc-booking__step hbc-booking__personal-call');
    step.appendChild(element('p','hbc-booking__eyebrow','Final step'));
    step.appendChild(element('h3','hbc-booking__step-heading','You Have Done The Preparation'));
    step.appendChild(element('p','hbc-booking__step-copy','Call the head coach now to discuss availability and agree your exact one-to-one session time. Your plan and online waiver are ready.'));
    var script=element('div','hbc-booking__call-script');script.appendChild(element('strong','','What to say'));script.appendChild(element('p','',this.personalCallScript()));step.appendChild(script);
    step.appendChild(element('p','hbc-booking__personal-fee-warning','YOUR SESSION IS NOT BOOKED UNTIL THE COACH AGREES A DATE AND TIME WITH YOU ON THE PHONE.'));
    var call=this.personalButton('CALL 07976848371','personal-call',false);call.classList.add('hbc-booking__call-button');step.appendChild(call);
    step.appendChild(element('p','hbc-booking__membership-fine-print','Calling opens your phone app. The website does not create a booking, reserve a time, send an email or notify staff at this stage.'));
    step.appendChild(this.personalActions('personal-details',null));
    return step;
  };

  HbcBooking.prototype.renderPersonalCallReturn = function () {
    var step=element('div','hbc-booking__step hbc-booking__personal-call hbc-booking__personal-call--return');
    step.appendChild(element('p','hbc-booking__eyebrow','Call step opened'));
    step.appendChild(element('h3','hbc-booking__step-heading','Did The Coach Confirm Your Time?'));
    step.appendChild(element('p','hbc-booking__call-confirmed','If the coach answered and gave you a date and time, your one-to-one session is booked.'));
    step.appendChild(element('p','hbc-booking__submission-notice','If the call was unanswered, cancelled, or no time was agreed, you are not booked yet. Call again to finalise your session.'));
    var call=this.personalButton('CALL AGAIN - 07976848371','personal-call',false);call.classList.add('hbc-booking__call-button');step.appendChild(call);
    step.appendChild(this.personalActions(null,'close-success','Close'));
    return step;
  };

  HbcBooking.prototype.loadPersonalAvailability = function () {
    var self=this; this.personalAvailabilityLoaded=false; this.personalError=''; this.renderFlow();
    fetch(this.apiUrl,{method:'POST',headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify({type:'one-to-one-availability'}),redirect:'follow',credentials:'omit'})
      .then(function(r){if(!r.ok)throw new Error();return r.json();}).then(function(data){if(!data||!data.ok||!Array.isArray(data.sessions)||!Array.isArray(data.calendarDays))throw new Error();self.personalAvailability=data.sessions;self.personalCalendarDays=data.calendarDays;var firstAvailable=data.calendarDays.find(function(day){return day.availableCount>0;});self.personalCalendarDate=firstAvailable?firstAvailable.date:(data.calendarDays[0]?data.calendarDays[0].date:'');self.personalAvailabilityLoaded=true;self.renderFlow();})
      .catch(function(){self.personalAvailabilityLoaded=true;self.personalError='One-to-one availability could not be loaded. Please try again or contact the club.';self.renderFlow();});
  };

  HbcBooking.prototype.renderPersonalSessions = function () {
    var wrapper=element('div'); wrapper.appendChild(element('h3','hbc-booking__step-heading','Choose your one-to-one session'));
    if(!this.personalAvailabilityLoaded){wrapper.appendChild(element('p','hbc-booking__step-copy','Loading available coaching times...'));return wrapper;}
    if(this.personalError){wrapper.appendChild(element('div','hbc-booking__submission-error',this.personalError));var retry=this.personalButton('Retry Availability','personal-retry-availability',false);wrapper.appendChild(retry);wrapper.appendChild(this.personalActions('personal-details',null));return wrapper;}
    if(!this.personalCalendarDays.length){wrapper.appendChild(element('p','hbc-booking__submission-notice','No one-to-one dates are currently available. Please contact the club on 07976848371.'));wrapper.appendChild(this.personalActions('personal-details',null));return wrapper;}
    var dates=this.personalCalendarDays.map(function(day){return day.date;});
    var calendar=element('div','hbc-booking__personal-calendar');
    calendar.appendChild(element('h4','','Choose an available date'));
    var dateGrid=element('div','hbc-booking__personal-date-grid'),selectedCalendarDate=this.personalCalendarDate||dates[0];
    var self=this;dates.forEach(function(date){
      var parts=date.split('-').map(Number),instant=new Date(Date.UTC(parts[0],parts[1]-1,parts[2],12));
      var day=self.personalCalendarDays.find(function(item){return item.date===date;});
      var button=element('button','hbc-booking__personal-date'+(date===selectedCalendarDate?' is-selected':'')+(!day.availableCount?' is-full':''));
      button.type='button';button.dataset.personalChoice='calendar-date';button.dataset.personalValue=date;
      button.append(element('small','',new Intl.DateTimeFormat('en-GB',{weekday:'short',timeZone:'UTC'}).format(instant)),element('strong','',String(parts[2])),element('span','',new Intl.DateTimeFormat('en-GB',{month:'short',timeZone:'UTC'}).format(instant)),element('em','',day.availableCount?day.availableCount+' available':'Fully booked'));
      dateGrid.appendChild(button);
    });
    calendar.appendChild(dateGrid);
    calendar.appendChild(element('p','hbc-booking__field-help','Only available dates are shown. Busy times from the club calendar are removed automatically.'));
    wrapper.appendChild(calendar);
    var selectedDate=this.personalCalendarDate||dates[0],selectedDay=this.personalCalendarDays.find(function(day){return day.date===selectedDate;}),grid=element('div','hbc-booking__personal-times');
    (selectedDay?selectedDay.slots:[]).forEach(function(slot){var available=slot.status==='available',button=element('button','hbc-booking__choice hbc-booking__personal-time '+(available?'is-available':'is-booked'));button.type='button';button.disabled=!available;if(available){button.dataset.personalChoice='session';button.dataset.personalValue=selectedDate+'T'+slot.time;}button.append(element('strong','',slot.time+' - '+oneHourLater(slot.time)),element('span','',available?'Available':'Booked'));grid.appendChild(button);});
    wrapper.appendChild(grid);wrapper.appendChild(this.personalActions('personal-details',null));return wrapper;
  };

  HbcBooking.prototype.renderPersonalReview = function () {
    var wrapper=element('div'); wrapper.appendChild(element('h3','hbc-booking__step-heading','Review Your Session'));
    var card=element('div','hbc-booking__personal-review');
    var goals=this.personalPlan.primaryGoals.map(function(goal){return goal==='Something else'?this.personalPlan.customGoal:goal;},this);
    var focuses=this.personalPlan.focusAreas.map(function(focus){return focus==='Something else'?this.personalPlan.customFocus:focus;},this);
    [ONE_TO_ONE.name,'1-hour session','£60',longDate(this.selectedSession)+' at '+this.selectedSession.time,this.details.firstName+' '+this.details.lastName,this.details.phone,this.details.email,'Main goals: '+goals.join(', '),'Focus: '+focuses.join(', ')].forEach(function(value){card.appendChild(element('p','',value));});
    if(this.personalPlan.hasHealthConsiderations) card.appendChild(element('p','hbc-booking__personal-health-summary','Health information provided'));
    wrapper.appendChild(card);
    wrapper.appendChild(element('p','hbc-booking__personal-fee-warning','CANCELLATIONS MUST BE MADE AT LEAST 48 HOURS BEFORE YOUR SESSION. IF LESS THAN 48 HOURS\u2019 NOTICE IS GIVEN, THE FULL \u00A360 FEE WILL BE CHARGED BECAUSE THE RESERVED COACHING SLOT CANNOT BE REUSED.'));
    var agreement=element('label','hbc-booking__personal-agreement'),box=element('input');box.type='checkbox';box.checked=this.cancellationAccepted;box.dataset.personalField='cancellationAccepted';agreement.append(box,document.createTextNode(' I understand that cancellations made with less than 48 hours’ notice will still require payment of the £60 session fee.'));wrapper.appendChild(agreement);
    if(this.personalError) wrapper.appendChild(element('div','hbc-booking__submission-error',this.personalError));
    wrapper.appendChild(this.personalActions('personal-sessions','personal-submit',this.submitting?'Confirming...':'Confirm One-to-One Session',this.submitting||!this.cancellationAccepted)); return wrapper;
  };

  HbcBooking.prototype.handlePersonalAction = function (action) {
    var map={'personal-intro':'personal-intro','personal-goal':'primary-goal','personal-experience':'experience','personal-focus':'focus-areas','personal-health':'health','personal-preferences':'preferences','personal-summary':'plan-summary','personal-details':'customer-details'};
    if(action==='personal-close') return this.closeModal();
    if(action==='personal-retry-availability'){this.loadPersonalAvailability();return;}
    if(action==='personal-sessions') {
      var errors=this.validateDetails();if(Object.keys(errors).length)return this.showValidation(errors);
      this.personalStage='customer-checking';this.renderFlow();var self=this;
      this.fastCustomerLookup({firstName:this.details.firstName,lastName:this.details.lastName,phone:this.details.phone,email:this.details.email})
        .then(function(data){
          if(!data||!data.ok)throw new Error();self.customerProfile=data;self.waiverId=data.waiverFound?normaliseText(data.waiverId):'';
          if(!self.waiverId){var junior=self.personalPlan.ageRange==='Under 16'||self.personalPlan.ageRange==='16-17';self.selectedClass.minimumAge=junior?11:18;self.selectedClass.levels=[junior?'Junior':'Adult'];self.waiver=junior?emptyJuniorWaiver():emptyAdultWaiver();if(junior){self.waiver.juniorFirstName=self.details.firstName;self.waiver.juniorLastName=self.details.lastName;self.waiver.mobileContactNumber=self.details.phone;self.waiver.email=self.details.email;self.preStage='junior-waiver';}else{self.waiver.firstName=self.details.firstName;self.waiver.lastName=self.details.lastName;self.waiver.phone=self.details.phone;self.waiver.email=self.details.email;self.preStage='adult-waiver';}self.renderFlow();return;}
          self.personalStage='call-contact';self.renderFlow();
        }).catch(function(){self.personalStage='customer-details';self.personalError='We could not check your details. Please try again.';self.renderFlow();});return;
    }
    if(action==='personal-call'){
      this.personalStage='call-pending';rememberBookingDetails(this.details);this.renderFlow();this.announce('Phone app opened. Your session is only booked if the coach confirms a date and time.');
      window.setTimeout(function(){window.location.href='tel:07976848371';},80);return;
    }
    if(action==='personal-submit'){
      if(ONE_TO_ONE_PHONE_ONLY){this.personalStage='call-contact';this.renderFlow();return;}
      return this.submitOneToOne();
    }
    if(map[action]){this.personalStage=map[action];this.renderFlow();}
  };

  HbcBooking.prototype.submitOneToOne = function () {
    if(ONE_TO_ONE_PHONE_ONLY){this.personalStage='call-contact';this.renderFlow();return;}
    var self=this;if(this.submitting||!this.selectedSession||!this.cancellationAccepted)return;
    if(this.personalPlan.firstTime==='Yes'&&!this.waiverId){var junior=this.personalPlan.ageRange==='Under 16'||this.personalPlan.ageRange==='16-17';this.selectedClass.minimumAge=junior?11:18;this.selectedClass.levels=[junior?'Junior':'Adult'];this.waiver=junior?emptyJuniorWaiver():emptyAdultWaiver();if(junior){this.waiver.juniorFirstName=this.details.firstName;this.waiver.juniorLastName=this.details.lastName;this.waiver.mobileContactNumber=this.details.phone;this.waiver.email=this.details.email;this.preStage='junior-waiver';}else{this.waiver.firstName=this.details.firstName;this.waiver.lastName=this.details.lastName;this.waiver.phone=this.details.phone;this.waiver.email=this.details.email;this.preStage='adult-waiver';}this.renderFlow();return;}
    this.submitting=true;this.personalStage='booking-submitting';this.personalError='';if(!this.bookingAttemptId)this.bookingAttemptId=window.crypto&&window.crypto.randomUUID?window.crypto.randomUUID():'hbc-'+Date.now();this.renderFlow();
    var payload=Object.assign({},this.personalPlan,{type:'one-to-one-booking',primaryGoal:this.personalPlan.primaryGoals.map(function(goal){return goal==='Something else'?this.personalPlan.customGoal:goal;},this).join(', '),focusAreas:this.personalPlan.focusAreas.map(function(focus){return focus==='Something else'?this.personalPlan.customFocus:focus;},this),firstName:this.details.firstName.trim(),lastName:this.details.lastName.trim(),phone:this.details.phone.trim(),email:this.details.email.trim(),sessionDate:this.selectedSession.date,sessionTime:this.selectedSession.time,serviceName:ONE_TO_ONE.name,price:60,durationMinutes:60,requestId:this.bookingAttemptId,waiverId:this.waiverId,cancellationAccepted:true});
    Object.keys(payload).forEach(function(key){if(typeof payload[key]==='string')payload[key]=payload[key].trim();if(typeof payload[key]==='undefined')delete payload[key];});
    var request=this.cloudflareUrl?postQueuedBookingPayload(this.cloudflareUrl,payload):postBookingPayload(this.apiUrl,payload,0);
    request.then(function(data){if(!data||!data.ok){var e=new Error();e.status=data&&data.status;e.publicMessage=data&&data.message;throw e;}self.success=data;self.processingCompletionPending=true;self.submitting=false;self.personalStage='booking-success';rememberBookingDetails(self.details);self.renderFlow();self.announce('Your one-to-one personal coaching session is confirmed.');}).catch(function(error){self.submitting=false;if(error.status==='waiver-required'){self.personalPlan.firstTime='Yes';self.personalStage='booking-review';self.submitOneToOne();return;}self.personalStage='booking-review';self.personalError=error.publicMessage||'We could not confirm your session. Your answers have been kept. Please try again.';self.renderFlow();});
  };

  HbcBooking.prototype.renderPersonalSuccess = function () {
    var success=element('div','hbc-booking__step hbc-booking__success hbc-booking__personal-success'),icon=element('div','hbc-booking__success-icon');icon.setAttribute('aria-hidden','true');icon.innerHTML='<svg viewBox="0 0 48 48"><path d="M10 25l9 9 19-21"/></svg>';success.appendChild(icon);success.appendChild(element('h3','','Your Session Is Confirmed'));
    [ONE_TO_ONE.name,'£60','1-hour session',longDate(this.selectedSession)+' at '+this.selectedSession.time,'Booking reference: '+(this.success.bookingId||'Confirmed')].forEach(function(value){success.appendChild(element('p','',value));});
    success.appendChild(element('p','hbc-booking__submission-notice','Please bring a water bottle and towel. All other equipment will be provided.'));
    success.appendChild(element('p','','A confirmation email has been sent. Check your spam or junk folder if it is not in your inbox.'));
    success.appendChild(element('p','','If you need to contact the head coach about your session, call or text 07976848371 immediately.'));
    success.appendChild(element('p','hbc-booking__personal-fee-warning','CANCELLATIONS MUST BE MADE AT LEAST 48 HOURS BEFORE YOUR SESSION. IF LESS THAN 48 HOURS\u2019 NOTICE IS GIVEN, THE FULL \u00A360 FEE WILL BE CHARGED BECAUSE THE RESERVED COACHING SLOT CANNOT BE REUSED.'));
    var actions=element('div','hbc-booking__actions'),close=this.personalButton('Close','close-success',false);actions.appendChild(close);success.appendChild(actions);return success;
  };

  HbcBooking.prototype.resetFlow = function () {
    this.selectedClass = null;
    this.selectedSession = null;
    this.sessions = [];
    var remembered = savedBookingDetails() || {};
    this.details = {
      firstName: remembered.firstName || '', lastName: remembered.lastName || '',
      phone: displayUkMobile(remembered.phone), email: remembered.email || '', attendedBefore: ''
    };
    this.customerStatus = '';
    this.preStage = 'booking';
    this.waiver = null;
    this.waiverId = '';
    this.waiverError = '';
    this.waiverAttemptId = '';
    this.waiverValidationErrors = {};
    this.photoPreparationId += 1;
    this.photoPreparing = false;
    this.bookingAttemptId = '';
    this.customerProfile = null;
    this.lookupSignature = '';
    this.submissionError = '';
    this.success = null;
    this.step = 1;
    this.renderFlow();
  };

  HbcBooking.prototype.clearSensitiveState = function () {
    this.selectedClass = null;
    this.selectedSession = null;
    this.sessions = [];
    this.details = { firstName: '', lastName: '', phone: '+44 ', email: '', attendedBefore: '' };
    this.customerStatus = '';
    this.preStage = 'booking';
    this.waiver = null;
    this.waiverId = '';
    this.waiverError = '';
    this.waiverAttemptId = '';
    this.waiverValidationErrors = {};
    this.photoPreparationId += 1;
    this.photoPreparing = false;
    this.bookingAttemptId = '';
    this.customerProfile = null;
    this.lookupSignature = '';
    this.submissionError = '';
    this.success = null;
    this.step = 1;
    this.journey = 'group';
    this.personalStage = 'personal-intro';
    this.personalPlan = emptyOneToOnePlan();
    this.personalAvailability = [];
    this.personalCalendarDays = [];
    this.personalAvailabilityLoaded = false;
    this.personalCalendarDate = '';
    this.personalError = '';
    this.cancellationAccepted = false;
    this.membershipStage = 'membership-intro';
    this.membershipError = '';
  };

  HbcBooking.prototype.announce = function (message) {
    var announcer = this.root.querySelector('[data-booking-announcer]');
    announcer.textContent = '';
    window.setTimeout(function () { announcer.textContent = message; }, 20);
  };

  function initialise(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-hbc-booking-section]')) roots.push(scope);
    roots = roots.concat(Array.from(scope.querySelectorAll('[data-hbc-booking-section]')));
    roots.forEach(function (root) {
      if (root.dataset.hbcBookingInitialised) return;
      root.dataset.hbcBookingInitialised = 'true';
      new HbcBooking(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  } else {
    initialise(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialise(event.target);
  });
})();
